{
  "Actions": {
    "actions": "Acciones",
    "back": "Atrás",
    "click here": "Haga clic aquí",
    "collapse": "Contraer",
    "expand": "Ampliar",
    "go to vehicle": "ver vehículo"
  },
  "Alert": {
    "Account is already activated": "La cuenta ya está activada.",
    "action failed": "La acción no pudo realizarse debido a un error",
    "add company card success": "Se ha añadido correctamente una nueva tarjeta de empresa.",
    "add driver success": "Conductor añadido correctamente",
    "add integration success": "Integración creada correctamente.",
    "add vehicle empty imei info": {
      "description": "El vehículo no tiene asignado ningún IMEI y no podrá descargar archivos. Añada un IMEI válido para descargar los archivos del vehículo.",
      "title": "Vehículo añadido correctamente, pero no se le ha asignado ningún IMEI."
    },
    "add vehicle success": "Vehículo añadido correctamente",
    "An unhandled error occured while processing this request": "Ha ocurrido un error al procesar la solicitud",
    "Another driver is registered under this card number.": "Ya existe otro conductor registrado con este número de tarjeta.",
    "apply all driver schedules success": "Horario añadido correctamente a todos los conductores.",
    "apply all vehicle schedules success": "Horario añadido correctamente a todos los vehículos.",
    "apply driver schedules success": "Horario añadido correctamente a {{resourceCount}} conductores.",
    "apply vehicle schedules success": "La programación se ha añadido correctamente a {{resourceCount}} vehículos.",
    "cancel invitation success": "La invitación se ha cancelado correctamente.",
    "Card number must be 16 characters in length.": "El ID del conductor debe tener 16 caracteres.",
    "CCA file download success": "Se ha descargado correctamente el autenticador de tarjetas de empresa.",
    "Comment must not be longer than 255 characters.": "El número máximo de caracteres para la descripción es 255.",
    "Company card with such ID already exists.": "Ya existe una tarjeta de empresa con este ID.",
    "Company card with such name already exists.": "Ya existe una tarjeta de empresa con este nombre.",
    "Company not found": "No se ha encontrado la empresa.",
    "Company not found.": "No se ha encontrado la empresa.",
    "Company with this LZ client code already exists.": "Ya existe una empresa con este código de Teltonika.",
    "create client company success": "Se ha creado correctamente una nueva empresa cliente.",
    "create company success": "Empresa creada con éxito.",
    "create schedule success": "Se ha creado correctamente el nuevo horario.",
    "credits overdraft activated": "Se ha activado correctamente el descubierto en cuenta",
    "credits overdraft deactivated": "Se ha desactivado correctamente el descubierto en cuenta",
    "disable integration success": "Integración desactivada correctamente.",
    "Driver duplication.": "Duplicación de conductores.",
    "Driver name contains invalid characters.": "El nombre del conductor contiene caracteres no válidos.",
    "Driver name must be 3-50 characters long.": "El nombre del conductor debe tener entre 3 y 50 caracteres.",
    "Driver with such card number already exists.": "Ya existe un ID de conductor con ese valor",
    "Drivers schedules were not found": "No se han encontrado los horarios de los conductores.",
    "edit company card success": "Tarjeta de empresa editada correctamente.",
    "edit integration success": "Integración editada correctamente.",
    "edit schedule success": "Horario editado correctamente.",
    "edit user description": "Los cambios surtirán efecto una vez que el usuario cierre la sesión.",
    "Email recipient was not found.": "No se ha encontrado el destinatario del correo electrónico.",
    "email transfer edit recipient success": "El destinatario del correo electrónico se ha editado correctamente.",
    "email transfer new recipient success": "El destinatario del correo electrónico se ha añadido correctamente.",
    "email transfer remove recipient success": "El destinatario del correo electrónico se ha eliminado correctamente.",
    "enable integration success": "Integración habilitada correctamente.",
    "error": {
      "import failed": "No se ha podido importar el archivo. Elimina el archivo, comprueba que los datos se ajustan a la estructura requerida y vuelve a cargar el archivo.\n",
      "import failed description": "Elimine el archivo, compruebe que los datos se ajustan a la estructura requerida y vuelva a cargar el archivo.",
      "import failed title": "Error en la importación. Los datos no coinciden con la estructura del archivo."
    },
    "general settings update success": "Configuración modificada correctamente.",
    "global schedule success": "Se ha creado correctamente el calendario global.",
    "Id must be of digits and letters only": "El ID debe estar compuesto únicamente por dígitos y letras",
    "Id must be of length 6 to 8": "El ID debe tener entre 6 y 8 caracteres",
    "Imei must be 15 characters long.": "El IMEI debe tener 15 caracteres.",
    "Imei must be numeric.": "En el campo IMEI solo se permiten valores numéricos.",
    "integration editing cancelled": "Edición de integración cancelada.",
    "Integration is disabled. Enable it first before retrying": "La integración está desactivada. Actívala antes de volver a intentarlo.",
    "Invalid email address": "Correo electrónico no válido.",
    "Invalid format.": "Formato de archivo no válido",
    "LZ client code not found.": "No se ha encontrado el código de Teltonika.",
    "move company success": "La empresa «{{sourceCompany}}» se ha trasladado con éxito a «{{targetCompany}}».",
    "New name must be different from the current name.": "El nuevo nombre debe ser diferente del nombre actual.",
    "news created": "Noticia creada correctamente.",
    "news deleted": "Noticia eliminada correctamente.",
    "news edited": "Noticia editada correctamente.",
    "news published": "Noticia publicada correctamente.",
    "Number must be provided.": "Es necesario indicar el número.",
    "Number must not be longer than 30 characters.": "Se permiten hasta 30 caracteres para el número de matrícula",
    "One or more selected companies have child companies and cannot be deleted.": "Una o varias de las empresas seleccionadas tienen filiales y no se pueden eliminar.",
    "One or more validation errors occured while parsing csv file. Please use template file for reference.": "Se han producido uno o varios errores de validación al analizar el archivo CSV. Utilice el archivo de plantilla como referencia.",
    "One or more validation errors occured.": "Se han producido uno o varios errores de validación.",
    "quick schedule created": {
      "description": {
        "drivers": "La descarga de datos se iniciará tan pronto como se identifique la conexión del conductor a TachoSync.",
        "vehicles": "La descarga de datos se iniciará tan pronto como se detecte la conexión del vehículo a TachoSync."
      },
      "title": "Se ha creado correctamente el horario rápido.",
      "title multiple drivers": "Se ha creado correctamente un horario rápido para {{driverNum}} conductores.",
      "title multiple vehicles": "Se ha creado correctamente un plan de trabajo rápido para {{vehicleNum}} vehículos.",
      "title single driver": "Se ha creado correctamente el horario rápido."
    },
    "Quick schedule for vehicle is already created.": "Ya se ha creado un horario rápido para el vehículo.",
    "Quick schedule is already assigned to the driver.": "Ya se ha asignado un horario rápido al conductor.",
    "remove company card success": "Tarjeta de empresa eliminada correctamente.",
    "resend invitation success": "La invitación se ha reenviado correctamente.",
    "retry integration success": "Integración «{{integrationName}}» conectada correctamente.",
    "retry interrupted integration success": "La integración «{{integrationName}}» volverá a intentar sincronizar los archivos omitidos. Vuelve más tarde para comprobar el estado.",
    "session expired": "Tu sesión ha finalizado. Inicia sesión de nuevo.",
    "successfully activate vehicle multiple": "{{resourceString}} vehículos activados correctamente.",
    "successfully activate vehicle single": "Vehículo activado correctamente.",
    "successfully assigned schedules": {
      "multiple": "Horarios asignados correctamente.",
      "single": "Horario asignado correctamente."
    },
    "successfully deactivate vehicle multiple": "{{resourceString}} vehículos desactivados correctamente.",
    "successfully deactivate vehicle single": "Vehículo desactivado correctamente.",
    "successfully deleted": "{{resourceString}} eliminado correctamente.",
    "successfully edited": "{{resourceString}} editado correctamente.",
    "successfully exported": "$t(General##{{tableName}}) exportado correctamente.",
    "successfully imported": "{{resourceString}} importado correctamente.",
    "successfully move vehicles multiple": "{{resourceString}} se ha trasladado correctamente a {{companyString}}.",
    "successfully move vehicles single": "{{resourceString}} se ha trasladado correctamente a {{companyString}}.",
    "successfully remove driver schedules multiple": "Se han eliminado correctamente los horarios de los conductores de {{resourceString}}.",
    "successfully remove driver schedules single": "Se han eliminado correctamente los horarios del conductor {{resourceString}}.",
    "successfully remove vehicle schedules multiple": "Se han eliminado correctamente los horarios de los vehículos {{resourceString}}.",
    "successfully remove vehicle schedules single": ".",
    "successfully removed": "{{resourceString}} eliminado correctamente.",
    "The company with such name already exists.": "Ya existe una empresa con este nombre.",
    "User is already invited.": "El usuario ya ha sido invitado.",
    "User is not invited": "El usuario no ha sido invitado.",
    "Vehicle duplication.": "Duplicación de vehículos.",
    "Vehicle number contains invalid characters.": "El número de vehículo contiene caracteres no válidos.",
    "Vehicle schedule was not found": "No se ha encontrado el horario del vehículo.",
    "Vehicle successfully activated": "Vehículo activado correctamente.",
    "Vehicle with such IMEI already exists.": "Ya existe un vehículo con este IMEI",
    "Vehicle with such Imei number already exists.": "El IMEI ya existe.",
    "Vehicle with such number (VRN) already exists.": "Ya existe un vehículo con ese número de matrícula",
    "Vehicles schedules were not found": "No se han encontrado horarios de vehículos.",
    "You cannot delete a company you are a member of.": "No puedes eliminar una empresa que esté seleccionada actualmente. Selecciona otra empresa y repite la operación.\n"
  },
  "Auth": {
    "account verification": {
      "check autheticator": "Comprueba tu aplicación de autenticación",
      "check email": "Comprueba tu correo electrónico",
      "code required": "Se requiere código de verificación.",
      "code sent to email": "Código enviado a tu correo electrónico",
      "code valid": "El código es válido durante unos minutos",
      "enter code below": "e introduce el código que aparece a continuación para iniciar sesión."
    },
    "account verification description": "Se requiere un código de verificación. Comprueba tu aplicación de autenticación e introduce el código a continuación para iniciar sesión.",
    "authenticator": "Aplicación de autenticación",
    "authenticator verification description": "Se requiere un código de verificación. Comprueba tu aplicación de autenticación e introduce el código a continuación para iniciar sesión.",
    "back to sign in screen": "Volver a la pantalla de inicio de sesión",
    "check email": "Comprueba tu bandeja de entrada y haz clic en el enlace recibido para restablecer la contraseña.",
    "community forum": "Foro de soporte",
    "contact us": "Contáctenos",
    "create password": "Crear contraseña",
    "did not receive": "¿No has recibido el enlace?",
    "do not have account": "¿Aún no tienes una cuenta?",
    "email": "Correo electrónico",
    "enter current password": "Introduzca la contraseña actual",
    "enter email": "Introduce su correo electrónico registrado para recibir instrucciones de restablecimiento de contraseña",
    "enter here": "Entra aquí",
    "enter new password": "Introducir nueva contraseña",
    "enter numbers only": "Introduce solo números (0-9)",
    "example": "Por ejemplo:",
    "failed to login": "La dirección de correo electrónico o la contraseña que has introducido son incorrectas.",
    "forgot password": "¿Has olvidado su contraseña?",
    "forgot your password": "¿Has olvidado su contraseña?",
    "go to login": "Ir a inicio de sesión",
    "google authenticator": "Google Authenticator",
    "hide password": "Ocultar contraseña",
    "invalid email format": "Formato de correo electrónico no válido",
    "invalid password format": "Formato de contraseña no válido",
    "Invitation expired": "El enlace de invitación ha caducado o se ha cancelado.",
    "link sent": "¡El enlace se ha enviado!",
    "login title": "Iniciar sesión",
    "microsoft authenticator": "Microsoft Authenticator",
    "new password": "Nueva contraseña",
    "password": "Contraseña",
    "password changed": "Contraseña cambiada correctamente.",
    "privacy policy": "Al utilizar <1>TachoSync</1>, aceptas nuestra <3>Política de privacidad</3>.",
    "remember password": "¿Recuerdas tu contraseña?",
    "repeat new password": "Repite la nueva contraseña",
    "repeat password": "Repite la contraseña",
    "required": "Requisitos",
    "resend": "Reenviar",
    "reset password": "Restablecer contraseña",
    "send reset link": "Enviar enlace para restablecer la contraseña",
    "show password": "Mostrar contraseña",
    "sign in": "Iniciar sesión",
    "sign in to tacho": "Inicia sesión en su\ncuenta de TachoSync",
    "sign out": "Cerrar sesión",
    "sign up": "Regístrate",
    "teltonika telematics": "Teltonika Telematics",
    "terms and conditions": "Entiendo y acepto los <1>Términos de servicio de </1>Teltonika y el <2>Acuerdo de </2>tratamiento de datos.",
    "wiki": "Base de conocimientos de Telematics Wiki"
  },
  "Button": {
    "accept": "Aceptar",
    "accept all": "Aceptar todo",
    "accept selected": "Aceptar selección",
    "actions": "Acciones",
    "activate": "Activar",
    "add": "Añadir",
    "add driver": "Añadir conductor",
    "add integration": "Añadir integración",
    "add to schedule": "Añadir a la agenda",
    "add vehicle": "Añadir vehículo",
    "all drivers": "Todos los conductores",
    "all vehicles": "Todos los vehículos",
    "apply": "Solicitar",
    "assign": "Asignar",
    "back": "Atrás",
    "back to sign in": "Volver a Iniciar sesión",
    "cancel": "Cancelar",
    "change": "Cambiar",
    "child company": "Filial",
    "clear": "Borrar",
    "clear all": "Borrar todo",
    "close": "Cerrar",
    "confirm": "Confirmar",
    "continue": "Continuar",
    "continue to TachoSync": "Continuar en TachoSync",
    "copied": "Copiado",
    "copy to clipboard": "Copiar al portapapeles",
    "create": "Crear",
    "create schedule": "Crear horario",
    "deactivate": "Desactivar",
    "default view": "Vista predeterminada",
    "delete": "Eliminar",
    "deselect all": "Deseleccionar todo",
    "disable": "Desactivar",
    "don't apply": "No se aplica",
    "download": "Descargar",
    "edit": "Editar",
    "edit driver": "Editar conductor",
    "edit integration": "Editar integración",
    "edit vehicle": "Editar vehículo",
    "enable": "Habilitar",
    "export": "Exportar",
    "export drivers": "Exportar datos de los conductores",
    "export vehicles": "Exportar vehículos",
    "file settings": "Configuración de archivos",
    "filtered": "Filtrado",
    "filters": "Filtros",
    "find device": "Buscar dispositivo",
    "finish": "Finalizar",
    "first page": "Página de inicio",
    "generate": "Generar",
    "generate report": "Generar informe",
    "get started": "Empezar",
    "go back": "Volver",
    "import": "Importar",
    "import drivers": "Importar conductores",
    "import vehicles": "Importación de vehículos",
    "inline actions": {
      "cancel invitation": "Cancelar invitación",
      "download file driver": "Descargar",
      "download file vehicle": "Descargar",
      "download monitoring": "Supervisión de descargas",
      "download status": "Estado de la descarga",
      "edit analysis provider": "Editar",
      "edit company": "Editar empresa",
      "edit driver": "Editar conductor",
      "edit integration": "Editar integración",
      "edit user": "Editar usuario",
      "edit vehicle": "Editar vehículo",
      "resend invitation": "Reenviar invitación",
      "retry analysis provider": "Reintentar",
      "retry integration": "Reintentar"
    },
    "invite": "Invitar",
    "invite user": "Invitar a un usuario",
    "history": "Historial",
    "last page": "Página anterior",
    "max download files": "Solo puedes descargar {{maxNumber}} archivos a la vez",
    "more actions": "Más acciones",
    "more filters": "Más filtros",
    "more options": "Más opciones",
    "move": "Mover",
    "new client": "Nuevo cliente",
    "next": "Siguiente",
    "next month": "El mes que viene",
    "next page": "Página siguiente",
    "only essential": "Solo lo esencial",
    "open TachoSync": "Abrir TachoSync",
    "pages of": "de {{total}}",
    "pause": "Pausa",
    "previous": "Anterior",
    "previous month": "Mes anterior",
    "previous page": "Página anterior",
    "quick schedule": "Calendario rápido",
    "refresh page": "Actualizar página",
    "reject all": "Rechazar todo",
    "remove": "Eliminar",
    "remove schedules": "Eliminar horarios",
    "reset": "Restablecer",
    "reset to default": "Restablecer valores predeterminados",
    "resume": "Currículum",
    "return home": "Vamos a casa",
    "rows selected": "{{count}} Seleccionados",
    "save": "Guardar",
    "schedules": "Horarios",
    "select image": "Seleccionar imagen",
    "select rows": "Seleccionar filas",
    "selected": "Seleccionado",
    "send code": "Enviar código",
    "settings": "Configuración",
    "table view": "Vista de tabla",
    "testing connection": "Probando la conexión...",
    "verify": "Verificar",
    "yes": "Sí"
  },
  "Company cards": {
    "add new": "Añadir nuevo",
    "badge tooltip": {
      "Disconnected": "Se ha perdido la conexión con TachoSync.\nÚltima conexión {{connectionDate}}.",
      "Expired": "La tarjeta está desactivada porque ha caducado.",
      "Inactive": "No se ha podido establecer conexión con TachoSync",
      "Online": "Conectado a TachoSync y comunicándose activamente"
    },
    "card expired": "La tarjeta ha caducado: {{date}}",
    "card id": "ID de tarjeta",
    "card number": "Número de tarjeta",
    "card number tooltip": "El número de tarjeta se mostrará tras la primera autorización satisfactoria.",
    "cca version": "Versión CCA",
    "company card id": "N.º de identificación de la tarjeta de empresa",
    "edit card": "Editar tarjeta",
    "edit company card": "Editar ficha de empresa",
    "expiry": "Caducidad",
    "expiry date": "Fecha de caducidad: {{date}}",
    "expiry tooltip": "La fecha de caducidad de la tarjeta se mostrará tras la primera autorización correcta.",
    "latest version": "Últimas novedades",
    "remove card": "Extraer tarjeta",
    "remove company card": "¿Eliminar la tarjeta de empresa?",
    "remove company card description": "¿Estás seguro de que deseas eliminar la tarjeta de empresa «{{cardName}}»? Esta acción no se puede deshacer.",
    "status": "Estado",
    "update version warning": "Hay una versión más reciente disponible.  Te recomendamos que la actualices para obtener el mejor rendimiento.",
    "valid until": "Válido hasta",
    "version details after connection is established": "Los detalles de la versión aparecerán aquí tras la primera conexión con la tarjeta de empresa."
  },
  "Cookies": {
    "accept": "Aceptar",
    "always active": "Siempre activo",
    "analytics cookies": "Cookies de análisis",
    "analytics cookies description": "Estos rastreadores se utilizan con fines analíticos para recopilar datos que nos permiten comprender cómo interactúan los usuarios con nuestros sitios web. Esta información nos permite tanto mejorar el contenido como desarrollar funciones más eficaces que mejoren la experiencia del usuario. Esta categoría de cookies se puede desactivar.",
    "cookie banner message": "Nosotros y determinados terceros utilizamos cookies o tecnologías similares con fines técnicos y, con su consentimiento, para otros fines tal y como se especifica en la <1>política de cookies</1>.",
    "cookie modal title": "Utilizamos cookies",
    "cookie policy": "política de cookies",
    "essential cookies": "Cookies esenciales",
    "essential cookies description": "Estos rastreadores se utilizan para actividades estrictamente necesarias para operar o prestar el servicio que nos has solicitado y, por lo tanto, estas cookies no recopilan información sobre ti que pueda utilizarse con fines de marketing ni recuerdan los sitios que has visitado en Internet. Esta categoría de cookies no se puede desactivar.\n",
    "text": "Este sitio web almacena datos, como cookies, para habilitar las funciones necesarias del sitio, incluyendo la analítica."
  },
  "Dashboard": {
    "added": "Añadido",
    "Available": "Disponible",
    "cards": "Tarjetas",
    "card tooltips": {
      "connectivity": "<strong>En línea:</strong>\nEl dispositivo se ha conectado en las últimas 24 horas\n\n<strong>Sin conexión:</strong>\nEl dispositivo no se ha conectado en las últimas 24 horas\n\n<strong>Inactivo:</strong>\nEl dispositivo nunca ha establecido una conexión correcta con TachoSync",
      "driver downloads": "<strong>A tiempo:</strong>\n0–14 días desde la última descarga\n\n<strong>Próximamente:</strong>\n15–28 días desde la última descarga\n\n<strong>Vencido:</strong>\n29+ días desde la última descarga\n\n<strong>Sin descargas:</strong>\nAún no se ha realizado ninguna descarga",
      "vehicle downloads": "<strong>A tiempo:</strong>\n0–60 días desde la última descarga\n\n<strong>Próximamente:</strong>\n61–90 días desde la última descarga\n\n<strong>Vencido:</strong>\n91+ días desde la última descarga\n\n<strong>Sin descargas:</strong>\nAún no se ha realizado ninguna descarga"
    },
    "cc expiry": {
      "expired": "Caducado",
      "near expiry": "A punto de caducar",
      "near expiry tooltip": "Caduca en 3 meses",
      "upcoming expiry": "Próxima fecha de caducidad",
      "upcoming expiry tooltip": "Caduca en un plazo de 3 a 6 meses"
    },
    "company cards": "Tarjetas de empresa",
    "company cards expiration": "Caducidad de las tarjetas de empresa",
    "connectivity": "Conectividad",
    "connectivity tabs": {
      "company cards": "Tarjetas de empresa",
      "devices": "Dispositivos"
    },
    "credit overdraft activated": "El descubierto te permite utilizar hasta {{overDraftAmount}} créditos por encima de tu saldo.",
    "credits": "Créditos",
    "credits health": {
      "Healthy": "En buen estado",
      "InOverdraft": "En descubierto",
      "LimitReached": "Límite alcanzado",
      "LowCredits": "Pocos créditos",
      "OverdraftLimitReached": "Límite alcanzado"
    },
    "credits history": "Historial de créditos",
    "credits history actions": {
      "BonusCredits": "Créditos de bonificación",
      "CreditsExpiration": "Caducidad de los créditos",
      "Deduction": "Deducción mensual",
      "FreeTrial": "Se han añadido créditos de demostración",
      "MonthlyDeduction": "Deducción mensual",
      "Purchase": "Créditos añadidos",
      "WebTachoLicenseConversion": "Migración"
    },
    "credits statuses": {
      "available": "Disponible",
      "balance": "Saldo",
      "overdraft": "Descubierto",
      "remaining overdraft": "Saldo pendiente del descubierto",
      "reserved": "Reservado"
    },
    "Deactivated": "Desactivado",
    "deducted": "Deducido",
    "demo credits": {
      "demo": "Demostración",
      "demo credits expired tooltip": "Los créditos de la demo han caducado. Compra créditos para seguir utilizando TachoSync.",
      "demo credits used up tooltip": "Se han agotado todos los créditos de demostración. Compra créditos para seguir utilizando TachoSync.",
      "demo info tooltip": "Los créditos de demostración se activan tras la primera conexión del IMEI y permanecen activos durante 90 días."
    },
    "device status": "Estado del dispositivo",
    "devices": "Dispositivos",
    "driver data": "Datos del conductor",
    "driver downloads": "Descargas del conductor",
    "DueSoon": "Próximamente",
    "estimated": "Estimado",
    "expires": "Caduca",
    "how credits work": {
      "bottom content": {
        "header": "¿Cuándo se reserva un crédito?",
        "table": {
          "body": {
            "any": "Cualquiera",
            "any behaviour": "No se concederá ningún crédito nuevo. Las reservas existentes se mantendrán hasta final de mes.",
            "newly assigned": "Recién asignado",
            "newly assigned behaviour": "Reservado al conectarse. Migrado a VIN tras la primera descarga.",
            "replaced vin known": "Sustituido (número de bastidor conocido)",
            "replaced vin known behaviour": "No se concede ningún crédito nuevo. La reserva existente sigue vigente.",
            "none": "Ninguno",
            "none behaviour": "No se reserva ningún crédito. Las descargas no se iniciarán hasta que se asigne un dispositivo."
          },
          "head": {
            "credit behaviour": "Comportamiento crediticio",
            "device": "Dispositivo",
            "vehicle status": "Estado del vehículo"
          }
        }
      },
      "button tooltip": "Descubre cómo funcionan los créditos",
      "main description": "Los créditos de TachoSync tienen una validez de 12 meses. Cada nueva compra amplía la fecha de caducidad otros 12 meses, lo que garantiza que tus créditos sigan estando disponibles mientras mantengas tu cuenta activa.",
      "main title": "Cómo funcionan los créditos",
      "middle content": {
        "description": "El uso de créditos de tu flota refleja exactamente cuántos vehículos están activos, según el número de bastidor (VIN) único. Los dispositivos se pueden sustituir, trasladar de un vehículo a otro o reasignar entre filiales sin consumir ningún crédito adicional, siempre y cuando la identidad del vehículo ya esté establecida.",
        "header": "Los créditos se reservan por vehículo activo, no por dispositivo.",
        "read more on wiki": "Más información en la Wiki"
      },
      "top content": {
        "active vehicle": "Vehículo activo",
        "device can change freely": "El dispositivo se puede cambiar libremente",
        "equals one credit": "= 1 crédito",
        "identified by IMEI": "Identificados por IMEI",
        "identified by VIN": "Identificado por el número de bastidor (VIN)",
        "tracking device": "Dispositivo de seguimiento"
      }
    },
    "Inactive": "Inactivo",
    "last 12 months": "Últimos 12 meses",
    "news": "Noticias",
    "no history to show": "No hay historial que mostrar",
    "no news": "No hay noticias que mostrar",
    "no results": "No hay resultados",
    "NoDownloads": "Sin descargas",
    "Offline": "Sin conexión",
    "Online": "En línea",
    "OnTime": "A tiempo",
    "Overdue": "Vencido",
    "Remaining": "Restante",
    "Reserved": "Reservado",
    "response error": "Ha ocurrido un error. Intenta actualizar la página",
    "timeline": "Cronología",
    "tooltip": {
      "click to expand": "Haz clic para ampliar",
      "connected card expire soon": "La tarjeta caducará pronto: {{expirationDate}}",
      "disconnected card": "La tarjeta de empresa está desconectada.\nÚltima conexión: {{lastSeen}}.",
      "disconnected card expire soon": "La tarjeta de empresa está desconectada.\nÚltima conexión: {{lastSeen}}. \n \n La tarjeta caducará pronto: {{expirationDate}}.",
      "expired card": "La tarjeta ha caducado el {{expirationDate}}. Sustituye la tarjeta de empresa por una válida.\n",
      "offline card": "La tarjeta de empresa está desconectada.\nÚltima conexión: {{lastSeen}}.",
      "take me there": "Llévame allí"
    },
    "Upcoming charge": "Próximo cargo",
    "vehicle data": "Datos del vehículo",
    "vehicle downloads": "Descargas de vehículos",
    "view history": "Ver historial"
  },
  "Date picker": {
    "disableFuture": "Fecha desactivada",
    "disablePast": "Fecha desactivada",
    "invalid date format": "Formato de fecha no válido",
    "invalidDate": "Fecha no válida",
    "maxDate": "Fecha incorrecta",
    "minDate": "Fecha incorrecta",
    "shouldDisableDate": "Fecha desactivada"
  },
  "Details": {
    "activities": "Actividades",
    "add new email recipient": {
      "choose a file format": "Elige un formato de archivo",
      "enter email": "Introduce tu correo electrónico",
      "title": "Añadir nuevo destinatario"
    },
    "api company id": "API ID de empresa",
    "autoAssignGlobalScheduleToDriver": "Asignar el horario global a los nuevos conductores",
    "autoAssignGlobalScheduleToVehicle": "Asignar el calendario global a los vehículos nuevos",
    "automaticDriverRegistrationEnabled": "Registro automático de nuevos conductores",
    "card holder": "Nombre del titular de la tarjeta",
    "client code": "Código de cliente",
    "close details": "Cerrar detalles",
    "company": "Empresa",
    "company cards": "Tarjetas de empresa",
    "company cards limit reached": "Has alcanzado el número máximo de tarjetas de empresa para esta empresa, {{currCount}}/{{maxCount}}.",
    "company settings": "Configuración de la empresa",
    "Completed": "Completado",
    "connection settings": "Configuración de conexión",
    "creator": "Creador",
    "credits": "Créditos",
    "credits overdraft tooltip": "Se ha actualizado la lógica de reserva de crédito mensual para permitir un saldo negativo en la cuenta. Esto contribuirá a una transición más fluida desde Web Tacho sin la presión de las compras inmediatas con crédito.",
    "current status": "Estado actual",
    "Daily": "Diario",
    "data types": "Tipos de datos",
    "deactivated": "Desactivado",
    "deactivated vehicle banner": {
      "description": "Este vehículo no acumulará nuevos créditos y no se podrán descargar los archivos del vehículo hasta que se active.",
      "link": "Activar vehículo",
      "title": "El vehículo está desactivado"
    },
    "detailed speed": "Velocidad detallada",
    "details": "Detalles",
    "device imei": "IMEI",
    "device status": "Estado del dispositivo",
    "download status": "Estado de la descarga",
    "download time": "Tiempo de descarga",
    "DownloadPending": "Descarga pendiente",
    "driver": "Conductor",
    "driver id": "Identificación del conductor",
    "driver status": "Estado del conductor",
    "drivers": "Conductores",
    "edit": "Editar",
    "edit user": "Editar {{userEmail}}",
    "email limit reached": "Has alcanzado el número máximo de correos electrónicos para esta empresa.",
    "email transfer": "Transferencia por correo electrónico",
    "email transfer info tooltip": "La función de transferencia por correo electrónico te permite recibir los datos descargados del tacógrafo a través del correo electrónico. Una vez completada la programación, el sistema reenviará automáticamente el correo electrónico a los destinatarios configurados. Cada empresa puede añadir hasta {{maxCount}} destinatarios de correo electrónico.",
    "endpointUrl": "URL del punto final",
    "events and faults": "Eventos y fallos",
    "Every  days": "Cada {{count}} días",
    "Every month": "Cada mes",
    "EveryDays": "Cada {{count}} días",
    "Feature not available in BETA version": "Función no disponible en la versión BETA",
    "file format": "Formato de archivo",
    "file sync": "Sincronización de archivos",
    "general": "General",
    "host": "Anfitrión",
    "imei": "IMEI",
    "included": "Incluido",
    "integration method": {
      "Ftps": "FTPS",
      "Sftp": "SFTP",
      "Webhook": "Webhook"
    },
    "last activity": "Última actividad",
    "last download attempt": "Último intento de descarga",
    "last successful download": "Última descarga realizada con éxito",
    "Never": "Nunca",
    "next download": "Siguiente descarga",
    "next download attempt": "Siguiente intento de descarga",
    "Next download attempt in  day": "Próximo intento de descarga en {{count}} días",
    "Next download attempt in  days": "Próximo intento de descarga en {{count}} días",
    "no company cards": "No se han añadido tarjetas de empresa.",
    "no driver schedule": "El conductor no tiene horarios asignados.",
    "no recipients added": "No hay destinatarios añadidos",
    "no vehicle schedule": "El vehículo no tiene horarios asignados.",
    "not included": "No incluido",
    "on next connection": "En la próxima conexión",
    "open files": "Abrir archivos",
    "open files disabled tooltip": "Este objeto no tiene archivos disponibles.",
    "other": "Otros",
    "overview": "Resumen",
    "parent company": "Empresa matriz",
    "password": "Contraseña",
    "port": "Puerto",
    "Quick schedule was completed": "Se completó el calendario rápido",
    "remotePath": "Ruta del directorio remoto",
    "remove": "Eliminar",
    "remove email recipient": {
      "description": "¿Estás seguro de que deseas eliminar a este destinatario del correo electrónico? Esta acción no se puede deshacer.",
      "title": "¿Eliminar {{userEmail}}?"
    },
    "remove schedule": "Eliminar horario",
    "reserved": "Reservado",
    "schedule details": "Detalles del calendario",
    "schedule history": "Historial de horarios",
    "schedule start time": "Hora de inicio del horario",
    "schedules": "Horarios",
    "show less": "Mostrar menos",
    "show more": "Mostrar más",
    "show older": "Mostrar más antiguos",
    "status": "Estado",
    "sub companies": "Filiales",
    "technical data": "Datos técnicos",
    "Upon device connection": "Conexión en el dispositivo",
    "username": "Nombre de usuario",
    "users": "Usuarios",
    "vehicles": "Vehículos",
    "vrn": "VRN",
    "WaitingForDeviceConnection": "Esperando a que se conecte el dispositivo",
    "WaitingForScheduleStartTime": "Esperando a que comience la hora programada"
  },
  "Dialog": {
    "account id": "ID de cuenta",
    "account id cannot contain more than": "El ID de cuenta no puede contener más de {{maxNumber}} caracteres",
    "activate vehicles": {
      "description": "Una vez activados, los vehículos podrán reservar créditos en función de una conexión mensual única. ¿Estás seguro de que quieres activar el siguiente número de vehículos?",
      "title": "¿Activar vehículos?"
    },
    "add": "Añadir",
    "add company card": "Añadir nueva ficha de empresa",
    "add driver": "Añadir conductor",
    "add integration": "Añadir integración",
    "add new integration": {
      "description": "Elige el tipo de integración que deseas añadir y configura los detalles en el siguiente paso.",
      "title": "Añadir nueva integración"
    },
    "add vehicle": "Añadir vehículo",
    "add vehicle description": "Añade un vehículo rellenando manualmente todos los datos de matriculación.",
    "add vehicle imei in use accessible": {
      "description": "Este IMEI ya está vinculado a otro vehículo. Si lo reasignas, ese vehículo dejará de poder descargar archivos. ¿Estás seguro de que quieres continuar?",
      "title": "IMEI ya en uso",
      "vehicle imei": "Vehículo con IMEI «{{imeiValue}}»:"
    },
    "all resource": "Todos los {{resource}}",
    "api key": "Clave API",
    "api key placeholder": "Introduce la clave API",
    "api key cannot contain more than": "La clave API no puede contener más de {{maxNumber}} caracteres",
    "api key edit": {
      "dialog title": "Editar clave API «{{keyName}}»",
      "success banner": "Clave API editada correctamente."
    },
    "api key name": "Nombre clave",
    "api key name required": "El nombre de la clave no puede estar vacío",
    "api key name too long": "El nombre de la clave no puede contener más de {{maxNumber}} caracteres",
    "api management": {
      "description": "Crea tu clave API para gestionar de forma segura el acceso a la API de nuestro sistema, lo que te permitirá una integración perfecta con tu propio software y flujos de trabajo. Puedes encontrar la documentación de la API de TachoSync en",
      "generated api key": "Clave API generada",
      "success banner": "La clave API se ha creado correctamente. Asegúrete de guardar la información que aparece a continuación, ya que no podrás volver a verla."
    },
    "cancel invitation": "Cancelar invitación",
    "cancel invitation description": "¿Estás seguro de que quieres cancelar la invitación de {{userEmail}}?",
    "card holder name": "Nombre del titular de la tarjeta",
    "card holder name not valid": "El nombre del titular de la tarjeta no puede contener más de {{maxNumber}} caracteres",
    "card holder name should not be empty": "El nombre del titular de la tarjeta no debe estar vacío",
    "card holder name too short": "El nombre del titular de la tarjeta debe contener al menos {{minNumber}} caracteres",
    "card id not valid": "El ID de la tarjeta no puede contener más de {{maxNumber}} caracteres",
    "card id should contain only digits, letters and hyphens": "El ID de la tarjeta solo debe contener dígitos (0-9), letras A-F y guiones (-).",
    "card id should contain only numbers": "El ID de la tarjeta solo debe contener números",
    "card id should not be empty": "El ID de la tarjeta no debe estar vacío",
    "card id too short": "El ID de la tarjeta debe contener al menos {{minNumber}} caracteres",
    "card name": "Nombre de la tarjeta",
    "card name not valid": "El nombre de la tarjeta no puede contener más de {{maxNumber}} caracteres",
    "card name should not be empty": "El nombre de la tarjeta no debe estar vacío",
    "card name too short": "El nombre de la tarjeta debe contener al menos {{minNumber}} caracteres",
    "choose period": "Seleccionar periodo",
    "client company": "Empresa cliente",
    "company": "Empresa",
    "company card id": "N.º de identificación de la tarjeta de empresa",
    "company name": "Nombre de la empresa",
    "company name in tachoSync": "Nombre de la empresa en TachoSync",
    "company name placeholder": "Por ejemplo: Teltonika Telematics",
    "company settings": {
      "allow credits overdraft": "Permitir uso por encima del crédito disponible",
      "auto add new drivers": "Registro automático de nuevos conductores",
      "auto add new drivers tooltip": "Tan pronto como se reconozca un nuevo ID de conductor, TachoSync lo añadirá automáticamente a la tabla de conductores.",
      "auto assign global schedule to drivers": "Asignar automáticamente el horario global a los nuevos conductores",
      "auto assign global schedule to drivers tooltip": "Aplica automáticamente un calendario de descargas global a los conductores recién registrados, lo que garantiza la descarga de datos sin intervención manual.",
      "auto assign global schedule to vehicles": "Asignar automáticamente el horario global a los vehículos nuevos",
      "auto assign global schedule to vehicles tooltip": "Aplica automáticamente un calendario de descargas global a los vehículos recién registrados, lo que garantiza la descarga de datos sin intervención manual.",
      "auto download driver data": "Descarga automática de los datos del conductor en la primera conexión",
      "auto download driver data tooltip": "Descarga automáticamente los datos de la tarjeta del conductor en la primera conexión del conductor. Esto garantiza la recopilación del historial completo de los nuevos conductores antes de configurar los horarios.",
      "auto update vehicle registration number": "Actualización automática del número de matrícula del vehículo (VRN)",
      "auto update vehicle registration number tooltip": "Cuando está activada, el VRN introducido al crear el vehículo se sobrescribe con el valor leído de los datos del tacógrafo tras la primera descarga correcta.",
      "automatic initial vehicle download": "Descarga automática de los datos del vehículo en la primera conexión",
      "automatic initial vehicle download tooltip": "Descarga automáticamente los datos del vehículo la primera vez que este se conecta. Esto garantiza la captura del historial completo de los vehículos nuevos antes de configurar los horarios.",
      "title": "Configuración de la empresa"
    },
    "confirm add schedule": "¿Añadir horario?",
    "confirm deactivate api key": {
      "description": "¿Estás seguro de que quieres desactivar la clave API «{{apiKeyName}}»?",
      "title": "¿Deshabilitar la clave API?"
    },
    "confirm deactivate integration": {
      "description": "¿Estás seguro de que quieres desactivar la integración «{{integrationName}}»?",
      "title": "¿Desea desactivar la integración?"
    },
    "confirm delete analysis providers": "¿Estás seguro de que quieres eliminar el siguiente número de proveedores de análisis? Esta acción no se puede deshacer.",
    "confirm delete api credentials": "¿Está seguro de que desea eliminar las credenciales de API seleccionadas? Esta acción no se puede revertir y cualquier llamada a la API realizada con estas credenciales será rechazada inmediatamente.",
    "confirm delete companies": "¿Estás seguro de que deseas eliminar la empresa seleccionada? Esta acción no se puede deshacer.",
    "confirm delete drivers": "¿Estás seguro de que desea eliminar el siguiente número de conductores?",
    "confirm delete integrations": "¿Estás seguro de que deseas eliminar el siguiente número de integraciones? Esta acción no se puede deshacer.",
    "confirm delete users": "¿Estás seguro de que desea eliminar el siguiente número de usuarios? Esta acción no se puede deshacer.",
    "confirm delete vehicles": "¿Estás seguro de que desea eliminar el siguiente número de vehículos?",
    "confirm empty imei": {
      "description": "No ha rellenado el campo IMEI. Los vehículos sin IMEI no pueden conectarse a TachoSync y no pueden descargar archivos.\n¿Está seguro de que desea continuar?",
      "title": "No se ha añadido ningún IMEI"
    },
    "convey integration": {
      "add": {
        "description": "Configura tu conexión a Convey",
        "title": "Añadir integración de Convey"
      },
      "edit": {
        "description": "Configura tu conexión a Convey",
        "title": "Editar la integración de Convey"
      },
      "provider settings description": "Asegúrate de utilizar las credenciales facilitadas por Convey.",
      "provider settings title": "Configuración del proveedor"
    },
    "create": "Crear",
    "create company": "Crear empresa",
    "create company main description": "Elige entre crear una nueva filial dentro de esta jerarquía o crear un nuevo cliente utilizando un código LZ de cliente.",
    "create new hierarchy": "Crear nueva jerarquía",
    "create news": "Crear noticia",
    "create news description": "Introducir brevemente el contenido del modal.",
    "create quick schedule": "Crear un horario rápido",
    "create schedule": "Crear horario",
    "create schedule description": "Configura descargas automáticas de archivos seleccionando una fecha, una hora y la periodicidad. El sistema se encargará de las descargas por ti, garantizando el cumplimiento normativo y la exactitud de los datos sin necesidad de intervención manual. No puedes fijar la hora de inicio de la programación en el pasado.\n",
    "credits history": {
      "description": "Controla tu saldo actual de créditos y consulta los datos históricos.\n",
      "description generate report": "Realiza un seguimiento de tu saldo actual de créditos, consulta datos históricos y genera un informe en formato «.csv» con todos los créditos consumidos en los últimos 12 meses.\n",
      "generate report description": "Elige cualquier periodo de los últimos 12 meses y genera un informe de los créditos consumidos.\n",
      "generate report title": "Generar informe",
      "title": "Historial de créditos"
    },
    "custom period": "Periodo personalizado",
    "date display format": "Formato de visualización de la fecha",
    "date range": "Intervalo de fechas",
    "deactivate vehicle": "Desactivar este vehículo",
    "deactivate vehicle description": "Los vehículos desactivados no acumularán nuevos créditos y se les bloqueará la descarga de datos",
    "deactivate vehicles": {
      "description": "Los vehículos desactivados no acumularán nuevos créditos y se les bloqueará la descarga de datos.",
      "title": "¿Desactivar vehículos?"
    },
    "delete": "Eliminar",
    "delete analysis providers": "¿Eliminar proveedores de análisis?",
    "delete api credentials": "¿Eliminar credenciales de la API?",
    "delete companies": "¿Eliminar empresas?",
    "delete companies warning": "La acción de eliminar empresas eliminará todos los recursos pertenecientes a dichas empresas.",
    "delete drivers": "¿Eliminar conductores?",
    "delete integrations": "¿Eliminar integraciones?",
    "delete news": "¿Eliminar noticia?",
    "delete news description": "¿Estás seguro de que deseas eliminar las noticias seleccionadas?",
    "delete unpublished release notes": "¿Eliminar notas de la versión no publicadas?",
    "delete unpublished release notes description": "¿Estás seguro de que deseas eliminar las notas de la versión no publicadas?",
    "delete users": "¿Eliminar usuarios?",
    "delete vehicles": "¿Eliminar vehículos?",
    "description": "Descripción (opcional)",
    "description not valid": "La descripción no puede contener más de {{maxNumber}} caracteres",
    "description required": "Descripción",
    "description should not be empty": "La descripción no debe estar vacía",
    "device imei": "IMEI del dispositivo",
    "dialog description": {
      "create company description": "El número máximo de niveles permitidos en el árbol de la empresa es {{maxNumber}}.",
      "create new hierarchy description": "El número máximo de niveles permitidos en el árbol de la empresa es {{maxNumber}}. Elija entre crear una nueva empresa secundaria dentro de esta jerarquía o crear un nuevo cliente utilizando un código LZ de cliente."
    },
    "download activities": "Descargar actividades",
    "download blocked message": "Descarga bloqueada: ponte en contacto con tu proveedor para resolver el problema.",
    "download data types": "Tipos de datos de descarga",
    "download drivers files": "Descargar archivos de controladores",
    "download history dialog title": "Historial del {{vehicleNumber}}",
    "download monitoring dialog tooltip": "Todos los datos de esta vista se actualizan automáticamente cada <strong>10 segundos</strong>.\nEl estado del dispositivo refleja la última conexión, no el estado actual del vehículo.",
    "download only selection": "Solo se descargarán los archivos seleccionados.",
    "download sample file message": "Descarga una <1>plantilla CSV de muestra</1> para ver un ejemplo del formato requerido.\n",
    "download status banners": {
      "CompanyCardExpired": "La tarjeta de empresa ha caducado. Por favor, introduce una tarjeta de empresa válida.",
      "InsufficientCredits": "Créditos insuficientes. Añade créditos para poder descargar archivos.",
      "NoCompanyCards": "La tarjeta de empresa debe estar conectada a Internet para iniciar la descarga. En este momento no hay ninguna disponible.",
      "NoSchedulesApplied": "A este vehículo no se le ha aplicado ningún horario.",
      "VehicleDeactivated": "Este vehículo está desactivado y no puede iniciar el proceso de descarga."
    },
    "download status dialog title": "Supervisión de descargas de {{vehicleNumber}}",
    "download vehicles files": "Descargar archivos de vehículos",
    "driver file destination": "Destino del archivo del conductor",
    "driver file destination tooltip": "Seleccione si los archivos del conductor se guardarán en la carpeta del vehículo del que se descargaron o en carpetas específicas para cada conductor según su ID.",
    "driver folder": "Carpeta del conductor",
    "driver id": "Identificación del conductor",
    "driver id not valid": "El ID del conductor debe contener {{maxNumber}} caracteres alfanuméricos",
    "driver id placeholder": "Por ejemplo: 360896050032309",
    "driver id should not be empty": "El campo «ID del conductor» no debe estar vacío",
    "driver name": "Nombre del conductor",
    "drivers folder naming": "Nombres de carpetas de conductores",
    "edit company": "Editar empresa «{{name}}»",
    "edit driver": "Editar conductor «{{name}}»",
    "edit news": "Editar noticia",
    "edit release notes tooltip": "Estas noticias se crean como notas de la versión y no se pueden modificar.",
    "edit user": "Editar usuario",
    "edit vehicle": "Editar vehículo «{{name}}»",
    "edit vehicle imei in use accessible": {
      "description": "Este IMEI ya está asignado a otro vehículo. Puede optar por intercambiar los IMEI entre los dos vehículos o sobrescribir el IMEI.",
      "title": "IMEI ya en uso"
    },
    "email": "Correo electrónico",
    "endpointUrl": "URL del punto final",
    "endpoint url": "URL del punto final",
    "endpoint url not valid": "La URL de destino no es válida",
    "endpoint url placeholder": "Introduce la URL",
    "enter": "Entrar",
    "enter company card id": "Introduce el ID de la tarjeta de empresa que se encuentra dentro de la aplicación Company Card Authenticator.\n",
    "enter here": "Entra aquí",
    "enter name": "Introduce el nombre",
    "enter password": "Introduce la contraseña",
    "enter username": "Introduce tu nombre de usuario",
    "expiration date optional": "Fecha de caducidad (opcional)",
    "export drivers": {
      "description": "Exporta todos los conductores de la empresa seleccionada a los archivos .csv requeridos.",
      "include drivers from all companies": "Incluir a los conductores de todas las empresas",
      "title": "Exportar conductores"
    },
    "export vehicles": {
      "description": "Exporta todos los vehículos de la empresa seleccionada a los archivos .csv correspondientes.",
      "include vehicles from all companies": "Incluir vehículos de todas las empresas",
      "title": "Exportar vehículos"
    },
    "feature switches": {
      "feature switches": "Conmutadores de funciones",
      "toggle integrations page": "Activar la página de integraciones"
    },
    "field cannot be changed": "Este campo no se puede modificar",
    "field cannot be empty": "{{fieldName}} no puede estar vacío",
    "field length not valid": "Este campo no puede contener más de {{maxNumber}} caracteres",
    "file format": "Formato de archivo",
    "filtered resource": "Filtrado por {{resource}}",
    "filtered drivers": "Conductores filtrados",
    "filtered vehicles": "Vehículos filtrados",
    "from": "De",
    "future dates": {
      "1 day": "en 1 día",
      "1 minute": "en 1 minuto",
      "1 month": "en 1 mes",
      "1 week": "en 1 semana",
      "1 year": "en 1 año",
      "hours and minutes": "en {{hourCount}}h {{minutesCount}}m",
      "less than a minute": "en <1 minuto",
      "multiple days": "en {{daysCount}} días",
      "multiple minutes": "en {{minutesCount}} minutos",
      "multiple months": "en {{monthsCount}} meses",
      "multiple weeks": "en {{weeksCount}} semanas",
      "multiple years": "en {{yearsCount}} años"
    },
    "generate api key": {
      "title": "Generar clave API"
    },
    "host": "Anfitrión",
    "host cannot contain more than": "El campo «Host» no puede contener más de {{maxNumber}} caracteres",
    "imei": "IMEI",
    "imei not valid": "El IMEI debe contener {{maxNumber}} caracteres numéricos",
    "imei placeholder": "Por ejemplo: 360896050032309",
    "imei should not be empty": "El IMEI no debe estar vacío",
    "import drivers": "Importar conductores",
    "import drivers description": "Añade conductores a tu lista importándolos desde un archivo.",
    "import vehicles": "Importación de vehículos",
    "import vehicles description": "Añade vehículos a tu lista importándolos desde un archivo.",
    "integration name": "Nombre de la integración",
    "integration type": "Tipo de integración",
    "integrations": {
      "deactivate integration": {
        "title": "Desactivar esta integración",
        "tooltip": "Desactiva temporalmente la integración. Puedes volver a activarla desmarcando esta opción."
      },
      "deactivate api key": "Desactivar clave API",
      "deactivate sftp": "Desactivar SFTP",
      "deactivate integration tooltip": "Desactiva temporalmente la integración. Puedes volver a activarla desmarcando esta opción.",
      "disable integration": {
        "description": "¿Estás seguro de que quieres desactivar la integración «{{integrationName}}»?",
        "title": "¿Deshabilitar la integración?"
      },
      "driver files info banner": "Tenga en cuenta que los archivos de los conductores descargados antes del {{formattedDate}} se colocarán en la carpeta del vehículo más reciente conducido por el conductor. ",
      "errors": {
        "AuthenticationFailed": {
          "description": "Asegúrate de que tu nombre de usuario y contraseña estén introducidos correctamente.\nLa integración se guardará con el estado «Fallida» hasta que introduzcas las credenciales correctas.\n",
          "title": "Credenciales incorrectas."
        },
        "FolderCreationFailed": {
          "description": "TachoSync está conectado al servidor, pero no tiene permiso para crear carpetas ni cargar archivos en la ruta de destino.\nLa integración se guardará con el estado «Fallida» hasta que se resuelva el problema y vuelvas a intentar conectarte.",
          "title": "Falta acceso de escritura."
        },
        "HostUnreachable": {
          "description": "Asegúrese de que la dirección y el puerto del servidor sean correctos y de que el servidor está en línea.\nLa integración se guardará con el estado «Fallida» hasta que se resuelva el problema y vuelvas a intentar conectarte.",
          "title": "Servidor no disponible."
        },
        "PathNotFound": {
          "description": "No se ha podido localizar el directorio especificado en el servidor. Asegúrese de que la ruta sea correcta.\nLa integración se guardará con el estado «Fallida» hasta que se indique la ruta correcta.",
          "title": "Ruta no encontrada."
        },
        "PermissionDenied": {
          "description": "\nLa integración se guardará con el estado «Fallida» hasta que se actualicen los permisos y vuelvas a intentar conectarte.",
          "title": "Permiso de ruta denegado."
        },
        "Unknown": {
          "description": "Se ha producido un error inesperado al intentar conectarse al servidor SFTP. Revisa los datos y la configuración de tu servidor.\nLa integración se guardará con el estado «Fallida» hasta que se resuelva el problema y vuelvas a intentar conectarte.",
          "title": "Se ha producido un error inesperado."
        }
      },
      "include files from all sub companies": "Incluir archivos de todas las sub empresas",
      "include files tooltip": "Si se selecciona, esta integración también recuperará archivos de todas las subempresas de tu cuenta",
      "include historical files": "Incluir archivos históricos",
      "include historical files tooltip": "Si se selecciona esta opción, también se recuperarán los archivos descargados antes de que se creara esta integración.",
      "select driver files destination": "Seleccionar destino de los archivos del conductor"
    },
    "introduce name": "Introducir nombre",
    "invite user": "Invitar a un usuario",
    "invite user description": "Una vez enviada la invitación, el usuario recibirá un \ncorreo electrónico con un enlace para crear una cuenta. El enlace tendrá una validez de 7 días.",
    "invite user sent": "Invitación de usuario enviada correctamente.",
    "loading": "Cargando...",
    "make release notes": "Crear notas de la versión",
    "make release notes info": "Si se selecciona este campo, la noticia se publicará en las Notas de la versión y el título se cambiará a Notas de la versión.",
    "max download files": "Número máximo de archivos permitidos por cada acción de descarga: {{maxNumber}}.",
    "move company": {
      "confirmation dialog": {
        "are you sure": "¿Estás seguro?",
        "description": "Estás a punto de trasladar «{{sourceCompany}}» a «{{targetCompany}}». Esta acción es irreversible, ¿estás seguro de que deseas continuar?"
      },
      "description": "Selecciona una empresa de origen y una empresa de destino a la que transferirla. La empresa de origen y sus recursos se trasladarán a la empresa de destino seleccionada. Esta acción es irreversible.",
      "error dialog": {
        "description": "El número máximo permitido de niveles de empresa es 4. Si se traslada aquí la empresa seleccionada, se superaría ese límite.",
        "title": "No es posible trasladar la empresa"
      },
      "info banner": "La empresa de origen conservará todos sus vehículos, conductores, archivos, empresas, usuarios, integraciones y horarios personalizados. Si se ha habilitado un horario global a nivel de la empresa raíz, este se heredará tras el traslado. De lo contrario, los horarios existentes se mantendrán tal y como están.",
      "source company": "Empresa de origen",
      "sftp warning": "La empresa seleccionada tiene un servidor SFTP en funcionamiento ya configurado. La conexión SFTP se interrumpirá mientras se realiza el traslado de la empresa. Una vez finalizado el traslado, se creará una nueva ruta SFTP y se reanudará la conexión.",
      "target company": "Empresa de destino",
      "title": "Traslado de la empresa"
    },
    "move vehicles": "Mover vehículos",
    "move vehicles info": "Nota: Los archivos de los vehículos permanecerán en la empresa actual. Se borrará el historial de descargas y se eliminarán los calendarios de descarga.",
    "name": "Nombre",
    "name not valid": "El nombre no puede contener más de {{maxNumber}} caracteres",
    "name should not be empty": "El nombre no debe estar vacío",
    "name too short": "El nombre debe contener al menos {{minNumber}} caracteres",
    "optional": "opcional",
    "overwrite imei checkbox": {
      "description": "Esta opción eliminará el IMEI de {{vehicleNumber}}.",
      "title": "Sobrescribir IMEI."
    },
    "parent company": "Empresa matriz",
    "password": "Contraseña",
    "password cannot contain more than": "La contraseña no puede contener más de {{maxNumber}} caracteres",
    "past dates": {
      "1 month ago": "Hace 1 mes",
      "1 week ago": "Hace 1 semana",
      "1 year ago": "Hace 1 año",
      "multiple months ago": "Hace {{monthCount}} meses",
      "multiple weeks ago": "Hace {{weekCount}} semanas",
      "multiple years ago": "{{yearCount}} hace años",
      "today": "Hoy",
      "yesterday": "Ayer"
    },
    "port": "Puerto",
    "port must be between": "El puerto debe estar comprendido entre los valores {{minNumber}} y {{maxNumber}}",
    "previous month": "Mes anterior",
    "provider": "Proveedor",
    "publish news": "¿Publicar noticias?",
    "publish news description": "Esta noticia está lista para publicarse. ¿Seguro que quieres continuar? Esta acción no se puede deshacer.",
    "publish release notes": "¿Publicar notas de la versión?",
    "publish release notes description": "Las notas de la versión están listas para publicarse. ¿Está seguro de que desea continuar? Esta acción no se puede deshacer.",
    "release notes": "Notas de la versión",
    "remote directory path cannot contain more than": "La ruta del directorio remoto no puede contener más de {{maxNumber}} caracteres",
    "remote directory path optional": "Ruta del directorio remoto (opcional)",
    "remove": "Eliminar",
    "remove schedules": "Eliminar horarios",
    "remove schedules confirmation description": {
      "drivers multiple": "¿Está seguro de que desea eliminar los horarios de {{resourceValue}} de los conductores seleccionados?",
      "drivers single": "¿Está seguro de que desea eliminar {{resourceValue}} de los conductores seleccionados?",
      "vehicles multiple": "¿Está seguro de que desea eliminar los horarios de {{resourceValue}} de los vehículos seleccionados?",
      "vehicles single": "¿Está seguro de que desea eliminar {{resourceValue}} de los vehículos seleccionados?"
    },
    "remove schedules description": {
      "drivers": "Seleccione uno o varios horarios que desee eliminar de los conductores seleccionados.",
      "vehicles": "Seleccione uno o varios horarios que desee eliminar de los vehículos seleccionados."
    },
    "resend invitation": "Reenviar invitación",
    "resend invitation description": "¿Estás seguro de que quieres reenviar la invitación a {{userEmail}}?",
    "role": "Función",
    "schedule apply to all": {
      "drivers": "El horario elegido se aplicará a todos los conductores de la empresa seleccionada.",
      "vehicles": "El horario elegido se aplicará a todos los vehículos de la empresa seleccionada."
    },
    "schedule apply to filtered": {
      "drivers": "El horario seleccionado se aplicará a los conductores filtrados mediante uno o varios de los filtros disponibles.",
      "vehicles": "El programa seleccionado se aplicará a los vehículos filtrados mediante uno o varios de los filtros disponibles."
    },
    "schedule apply to selected": {
      "drivers": "El horario elegido se aplicará a todos los conductores seleccionados mediante la casilla de verificación.",
      "vehicles": "El horario elegido se aplicará a todos los vehículos seleccionados mediante la casilla de verificación."
    },
    "schedule time tooltip description": "Si la hora seleccionada esta en el pasado, el sistema la ajustará automáticamente a la hora más cercana disponible en el futuro.",
    "security settings": "Configuración de seguridad",
    "security settings description": "Encuentra opciones que te permitan controlar cómo se protege tu cuenta.",
    "select": "Seleccionar",
    "select a company": "Selecciona una empresa",
    "select file format example": "Selecciona el formato (p. ej., .DDD)",
    "select format": "Seleccionar formato",
    "select image": "Seleccionar imagen",
    "select image description": "Seleccione la imagen que desee utilizar haciendo clic en ella y pulsando el botón Guardar.",
    "select schedules": "Seleccionar horarios",
    "selected resource": "Seleccionado {{resource}}",
    "selected drivers": "Conductores seleccionados",
    "selected vehicles": "Vehículos seleccionados",
    "selected role info message": "<3>Haga clic aquí</3> para ver la tabla detallada de permisos.",
    "selected role info message title": "El rol determinará los permisos de los usuarios en TachoSync.",
    "sftp integration": {
      "description": "Configure su conexión SFTP y defina cómo se estructurarán los archivos del tacógrafo.",
      "edit title": "Editar integración SFTP «{{integrationName}}»",
      "sftp name": "Nombre SFTP",
      "title": "Integración SFTP"
    },
    "sftp password": "Contraseña SFTP",
    "sftp server hostname or ip": "Nombre de host o IP del servidor SFTP",
    "sftp server port number": "Número de puerto del servidor SFTP",
    "sftp server settings": "Configuración del servidor SFTP",
    "sftp username": "Nombre de usuario SFTP",
    "Teltonika code": "Código Teltonika",
    "Teltonika code invalid characters": "El código de Teltonika debe tener una longitud de entre {{minCount}} y {{maxCount}} caracteres y puede incluir letras, números y puntos.",
    "Teltonika code placeholder": "El código de Teltonika debe tener entre {{minCount}} y {{maxCount}} caracteres",
    "Teltonika company name": "Nombre de la empresa",
    "time": "Hora",
    "time zone": "Zona horaria",
    "title": "Título",
    "title not valid": "El título no puede contener más de {{maxNumber}} caracteres",
    "title should not be empty": "El título no debe estar vacío",
    "title too short": "El título debe contener al menos {{minNumber}} caracteres",
    "to": "A",
    "toggle children global schedule linking": "Conectado a el Calendario global de la empresa matriz",
    "toggle children global schedule linking tooltip": "La empresa matriz ha habilitado la herencia del calendario global. Para editar el calendario global de la empresa seleccionada, desactive esta opción. Tenga en cuenta que esto desconectará el calendario global de la empresa raíz.",
    "toggle global schedule linking": "Aplicar el calendario global a todas las filiales",
    "toggle global schedule linking tooltip": "Al activar esta opción, se aplica el calendario global a todas las filiales. Las filiales pueden desactivar esta opción para personalizar su propio calendario global.",
    "toggle global schedule warning banner": "Es posible que algunas filiales ya estén utilizando un calendario global diferente. Esta opción no les afectará a menos que la seleccionen en la configuración de su calendario global.",
    "unpublished release notes": "Hay notas de la versión sin publicar.",
    "upload folder blank for root": "Carga la carpeta (en blanco para la raíz)",
    "username": "Nombre de usuario",
    "username cannot contain more than": "El nombre de usuario no puede contener más de {{maxNumber}} caracteres",
    "vdo integration": {
      "add": {
        "description": "Configura tu conexión de flota VDO.",
        "title": "Añadir integración de flotas VDO"
      },
      "edit": {
        "description": "Configura tu conexión de flota VDO.",
        "title": "Editar integración de flotas VDO"
      },
      "provider settings description": "Asegúrate de utilizar las credenciales facilitadas por VDO Fleet.",
      "provider settings title": "Configuración del proveedor"
    },
    "vehicle folder": "Carpeta del vehículo",
    "vehicle imei in use inaccessible": {
      "description": "Este IMEI ya está asignado a una empresa ajena a su grupo empresarial. Si un dispositivo con este IMEI le pertenece, póngase en contacto con <supportLink>el servicio de asistencia de Teltonika</supportLink>.",
      "title": "IMEI utilizado por otro grupo empresarial"
    },
    "vehicle name": "Nombre del vehículo",
    "vehicle number": "Número de matrícula del vehículo (VRN)",
    "vehicle registration number tooltip": "La actualización automática está habilitada en la configuración de su empresa. El VRN que introduzca aquí se sobrescribirá con el valor leído de los datos del tacógrafo tras la primera descarga correcta.",
    "vehicles folder naming": "Nombres de carpetas de vehículos",
    "vrn": "VRN",
    "vrn should not be empty": "El número de matrícula del vehículo no debe estar vacío",
    "welcome to beta version title": "¡Bienvenido a la prueba beta de TachoSync!"
  },
  "Download history": {
    "download successful": "Descarga realizada correctamente",
    "driver data": "Datos del conductor",
    "no history": "Aquí se mostrará el historial",
    "schedule": "Horario"
  },
  "Download monitoring": {
    "APDU packet reading error. Device disconnected.": "Error de lectura del paquete APDU. Dispositivo desconectado.",
    "Authenticating": "Autenticación",
    "Authentication failure (02x10)": "Error de autenticación (02x10)",
    "Authentication failure after timeout (02x01)": "Error de autenticación tras agotarse el tiempo de espera (02x01)",
    "Authentication failure after timeout (02x12)": "Error de autenticación tras el tiempo de espera (02x12)",
    "Card reading error. Please reinsert the company card, reconnect the card reader, or restart the service.": "Error al leer la tarjeta. Vuelve a insertar la tarjeta de empresa, vuelve a conectar el lector de tarjetas o reinicia el servicio.",
    "CheckingCredits": "Comprobación de créditos",
    "CompanyCardExpired": "Tarjeta de empresa caducada",
    "CompanyCardInUse": "Tarjeta de empresa en uso",
    "Could not download any of files": "No se ha podido descargar ningún archivo",
    "CreditReserved": "Derechos reservados",
    "Download rejected: device VIN doesn't match this vehicle's VIN record. If the device was moved to a new vehicle, create a new vehicle record to continue.": "Descarga rechazada: el VIN del dispositivo no coincide con el registro del VIN de este vehículo. Si el dispositivo se ha trasladado a un nuevo vehículo, crea un nuevo registro de vehículo para continuar.",
    "DownloadingDriverData": "Descarga de datos de los conductores",
    "DownloadingDriverDataFailed": "Error al descargar los datos del conductor",
    "DownloadingVehicleData": "Descarga de datos de vehículos",
    "Driver info packet reading error. Device disconnected.": "Error al leer el paquete de información del conductor. Dispositivo desconectado.",
    "Failed to download driver data": "No se han podido descargar los datos del conductor",
    "Failed to receive APDU from card, timeout exceeded": "No se ha podido recibir el APDU de la tarjeta; se ha superado el tiempo de espera",
    "Failed to receive VUReady packet from device, timeout exceeded": "No se ha podido recibir el paquete VUReady del dispositivo; se ha superado el tiempo de espera",
    "Failed to receive VUReady packet. If problem persists, check the telematics/tacho devices setup.": "No se ha podido recibir el paquete VUReady. Si el problema persiste, comprueba la configuración de los dispositivos telemáticos o tacográficos.",
    "InsufficientCredits": "Créditos insuficientes",
    "Lost connection with device or card": "Se ha perdido la conexión con el dispositivo o la tarjeta",
    "NoCompanyCards": "Sin tarjetas de empresa",
    "NoDueSchedules": "Sin plazos de vencimiento",
    "NoSchedulesApplied": "No se han aplicado horarios",
    "ProcessTerminated": "Proceso finalizado",
    "ReceivingDownloadList": "Recepción de la lista de descargas",
    "ReceivingDriverInfo": "Recepción de información sobre los conductores",
    "ReceivingDriversSchedules": "Recepción de los horarios de los conductores",
    "ReceivingStatusState": "Estado de recepción",
    "ReceivingVehicleSchedules": "Recepción de los horarios de los vehículos",
    "requirements": {
      "company card": "Tarjeta de empresa",
      "credits available": "Créditos disponibles",
      "ignition": "Arranque",
      "ignition unavailable tooltip": "Desconocido: el último estado conocido fue hace más de 2 horas.",
      "imei": "IMEI",
      "schedule assigned": "Horario asignado",
      "vehicle activated": "Activado por el vehículo",
      "reason": {
        "CompanyCardExpired": "La tarjeta de empresa ha caducado",
        "IgnitionNotReportedRecently": "Estado desconocido: no se ha notificado recientemente el estado del encendido. Se seguirá intentando la descarga, pero es menos probable que se realice con éxito",
        "IgnitionOff": "El contacto está apagado. Se seguirá intentando la descarga, pero es menos probable que se realice con éxito",
        "InsufficientCredits": "No hay créditos disponibles",
        "NoCompanyCardOnline": "Actualmente no hay ninguna tarjeta de empresa en línea",
        "NoCompanyCards": "Actualmente no hay ninguna tarjeta de empresa en línea",
        "NoImeiAssigned": "El vehículo no tiene asignado ningún IMEI",
        "NoScheduleAssigned": "El vehículo debe tener asignado un horario",
        "VehicleDeactivated": "Es necesario activar el vehículo para descargar los datos"
      }
    },
    "schedules": {
      "assign schedules": "Asignar horarios",
      "assign schedules dialog": {
        "description": "Elige uno o varios horarios que desees asignar.",
        "title": "Asignar horarios a {{vehicleNumber}}"
      },
      "fail reason": {
        "download requirements not met": "no se cumplen los requisitos de descarga."
      },
      "no schedules assigned": "A este vehículo no se le ha asignado ningún horario",
      "on device connection": "al conectar el dispositivo",
      "requirements not met": "La programación no se puede ejecutar hasta que se cumplan todos los requisitos."
    },
    "StageComplete": "Etapa completada",
    "Stages": {
      "Authentication": "Autenticación",
      "Downloading": "Descarga",
      "DownloadTrigger": "Desencadenante de descarga",
      "Initialization": "Inicialización"
    },
    "Status packet reading error. Device disconnected.": "Error al leer el paquete de estado. Dispositivo desconectado.",
    "TerminatingConnectionToDevice": "Se está cerrando la conexión con el dispositivo",
    "Timeout. Response from VU not received (02x01)": "Tiempo de espera agotado. No se ha recibido respuesta de la VU (02x01)",
    "Too many KeepAlive packets received.": "Se han recibido demasiados paquetes KeepAlive.",
    "Unexpected error": "Error inesperado",
    "Unexpected loss of connection with the device. Once device returns to normal connectivity, download will continue.": "Pérdida inesperada de conexión con el dispositivo. Una vez que el dispositivo recupere la conectividad normal, la descarga continuará.",
    "UploadingDriverFiles": "Carga de archivos de conductores",
    "UploadingDriverFilesFailed": "Error al cargar los archivos de los conductores",
    "UploadingVehicleFiles": "Carga de archivos de vehículos",
    "UploadingVehicleFilesFailed": "No se han podido cargar los archivos de los vehículos",
    "VehicleDeactivated": "Vehículo desactivado",
    "VuNotReady": "El vehículo no está listo. Se volverá a intentar en 5 minutos",
    "VU ready packet reading error. Device disconnected.": "Error de lectura del paquete «VU ready». Dispositivo desconectado.",
    "WaitingForDeviceConnection": "A la espera de que se conecte el dispositivo",
    "Wrong communication command": "Comando de comunicación incorrecto"
  },
  "Drivers": {
    "drivers page": "Conductores",
    "last activity": {
      "Available": "Disponible",
      "BreakOrRest": "Descanso",
      "Drive": "Conduciendo",
      "NotAvailable": "No disponible",
      "Undefined": "N/A",
      "Unknown": "Desconocido",
      "Unknown4": "Desconocido",
      "Unknown5": "Desconocido",
      "Work": "Trabajo"
    }
  },
  "Dropzone": {
    "add file": "Añadir archivo",
    "drop file to upload": "Arrastra el archivo para subirlo",
    "drop files to upload": "Arrastra los archivos para subirlos",
    "error uploading the file": "Se ha producido un error al cargar el archivo",
    "file invalid type": "Se ha seleccionado un tipo de archivo no válido.",
    "file successfully uploaded": "Archivo cargado correctamente",
    "file syntax": "La sintaxis del archivo es la siguiente:",
    "maximum file limit reached": "Se ha alcanzado el límite máximo de archivos.",
    "no image": "Sin imagen",
    "only one file can be attached": "Solo se puede adjuntar un archivo.",
    "or drop file to upload": "O bien, arrastra el archivo para subirlo",
    "or drop files to upload": "O bien, arrastra los archivos para subirlos",
    "row limit exceeded": "Se ha alcanzado el límite de importación de recursos. No se pueden importar más de {{rowLimit}} recursos.",
    "rows detected": "Se han detectado correctamente las filas del archivo",
    "select file": "Seleccionar archivo",
    "select file type": "Seleccione primero el tipo de archivo.",
    "select files": "Seleccionar archivos",
    "select image": "Seleccionar imagen:",
    "supported formats": "Formatos compatibles",
    "too long file name": "El nombre del archivo es demasiado largo. Se permite un máximo de {{maxLength}} caracteres.",
    "too many files description": "El resto de los archivos se pueden cargar una vez que hayas cargado los archivos seleccionados.",
    "too many files title": "El límite máximo de archivos que puede adjuntar a la vez es de {{maxFiles}}."
  },
  "Error": {
    "error": "Error",
    "message wait": "Ten paciencia hasta que solucionemos el error.",
    "title": "¡Ha ocurrido un error!"
  },
  "Files": {
    "files header info tooltip": "Los archivos descargados se almacenan en TachoSync durante dos años, transcurrido el tiempo se eliminan automáticamente del sistema."
  },
  "Filter": {
    "company": "Empresa",
    "credit status": "Situación crediticia",
    "deactivatedVehicles": "Vehículos desactivados",
    "device imei": "IMEI del dispositivo",
    "device status": "Estado del dispositivo",
    "driver": "Conductor",
    "filtered by": "Filtrado por",
    "filters used": "Filtros utilizados",
    "from to date": "{{fromDate}} a {{toDate}}",
    "last activity": "Última actividad",
    "last download": "Última descarga",
    "last download options": {
      "DueSoon": "Próximamente",
      "NoDownloads": "Sin descargas",
      "OnTime": "A tiempo",
      "Overdue": "Vencido",
      "Undefined": "N/A"
    },
    "more filters": "Más filtros",
    "noDeviceImei": "Ningún IMEI de dispositivo",
    "Not reserved": "Sin reservar",
    "Reserved": "Reservado",
    "schedule": "Horario",
    "schedule name": "Nombre del horario",
    "schedules": "Horarios",
    "select date": "Seleccionar fecha",
    "select date and time": "Selecciona fecha y hora",
    "Select date range": "Seleccionar intervalo de fechas",
    "status": "Estado",
    "table filters": "Filtros de tabla",
    "vehicle number": "Número de vehículo"
  },
  "General": {
    "Active": "Activo",
    "Administrator": "Administrador",
    "administrator role description": "Control total para crear, editar y eliminar todos los recursos.",
    "analysis provider": "Proveedor de análisis",
    "analysis providers": "Proveedores de análisis",
    "api credential": "Credenciales de API",
    "api credentials": "Credenciales de API",
    "Available": "Disponible",
    "Awaiting connection": "Esperando conexión",
    "badge": {
      "connected badge tooltip text": "Conectado correctamente a TachoSync y comunicándose activamente.",
      "deactivated badge tooltip text": "Este vehículo está desactivado y no consumirá créditos.",
      "inactive badge tooltip text": "Nunca se ha establecido una conexión correcta con TachoSync.",
      "offline badge tooltip text": "No se ha conectado a TachoSync en las últimas 24 horas",
      "online badge tooltip text": "Conectado en las últimas 24 horas"
    },
    "Blocked": "Bloqueado",
    "BreakOrRest": "Descanso",
    "business": "Negocios",
    "code expired": "Tu sesión ha caducado. Inicia sesión de nuevo.",
    "column": "Columna",
    "companies": "Empresas",
    "company": "Empresa",
    "Company administrator": "Administrador de la empresa",
    "Connected": "Conectado",
    "credits": "Créditos",
    "dashboard": "Panel de control",
    "Deactivated": "Desactivado",
    "Description": "Descripción",
    "Disabled": "Desactivado",
    "Disconnected": "Desconectado",
    "Drive": "Conduciendo",
    "driver data": "Datos del conductor",
    "drivers": "Conductores",
    "DueSoon": "Próximamente",
    "end": "Fin",
    "Expired": "Caducado",
    "Failed": "Error",
    "files": "Archivos",
    "here": "aquí",
    "history": "Historial",
    "Inactive": "Inactivo",
    "in progress": "en curso",
    "integration": "Integración",
    "integrations": "Integraciones",
    "integrations/analysisProviders": "Proveedores de análisis",
    "integrations/apicredentials": "Credenciales de API",
    "Interrupted": "Interrumpido",
    "InvalidConfiguration": "Error",
    "invitations": "Invitaciones",
    "latest version": "Última versión",
    "menu": "Menú",
    "NoDownloads": "Sin descargas",
    "not assigned": "Sin asignar",
    "Not reserved": "Sin reservar",
    "NotAvailable": "No disponible",
    "NotReserved": "Sin reservar",
    "Offline": "Sin conexión",
    "Online": "En línea",
    "OnTime": "A tiempo",
    "Pending": "Pendiente",
    "requirements": "Requisitos",
    "Reserved": "Reservado",
    "row": "Fila",
    "schedule": "Horario",
    "schedules": "Horarios",
    "show older": "Mostrar más antiguos",
    "start": "Inicio",
    "Successful": "Éxito",
    "Teltonika support": "Soporte de Teltonika",
    "Teltonika Support": "Asistencia técnica de Teltonika",
    "teltonika support role description": "Acceso especializado para soporte.",
    "Tooltip": {
      "accept beta terms": "Para continuar, desplázate hasta la parte inferior y acepta los términos."
    },
    "unauthorized": "No se ha podido autenticar al usuario",
    "Undefined": "N/A",
    "Unknown": "Desconocido",
    "Unknown4": "Desconocido",
    "Unknown5": "Desconocido",
    "User": "Usuario",
    "user role description": "Acceso básico con permisos limitados.",
    "users": "Usuarios",
    "vehicles": "Vehículos",
    "Work": "Trabajo",
    "year": "Año"
  },
  "Languages": {
    "english": "Inglés",
    "french": "Francés",
    "language": "Idioma"
  },
  "Navigation": {
    "collapse menu": "Cerrar menú",
    "expand menu": "Expandir menú"
  },
  "News": {
    "create news": "Crear noticia",
    "delete": "Eliminar",
    "edit": "Editar",
    "publish": "Publicar",
    "unpublished": "Sin publicar"
  },
  "Notifications": {
    "notifications": "Notificaciones"
  },
  "Password": {
    "account password": "Contraseña de la cuenta",
    "are you sure": "¿Estás seguro?",
    "change": "Cambiar",
    "change password": "Cambiar contraseña",
    "click to scan code": "Haga clic aquí para escanear un código QR",
    "click to type code": "Haga clic aquí para introducir el código manualmente",
    "disable description confirmation": "Está a punto de desactivar la autenticación de dos factores. Esto podría comprometer la seguridad de su cuenta de TachoSync. ¿Está seguro de que desea continuar?",
    "disable description send code": "Se ha enviado un código de 6 dígitos a su aplicación de autenticación. Por motivos de seguridad, introduzca el código generado en el campo siguiente.",
    "disable description send password": "Por motivos de seguridad, vuelva a introducir su contraseña actual.",
    "disable no access": "Si ya no tienes acceso a la aplicación de autenticación vinculada a esta cuenta, es necesario cambiar la contraseña para desactivar la autenticación de dos factores.",
    "disabled": "Desactivado",
    "disabled two FA": "Autenticación de dos factores desactivada correctamente.",
    "enabled": "Habilitado",
    "enter": "Entrar",
    "enter current password": "Introduzca la contraseña actual",
    "generate key description": "Para completar este proceso, necesitarás una aplicación móvil de autenticación, como alguna de las siguientes:",
    "incorrect code": "Código incorrecto",
    "incorrect password": "Contraseña incorrecta",
    "lowercase letter": "Al menos una letra minúscula (a-z)",
    "minimum characters": "Al menos {{maxNumber}} caracteres",
    "minimum digits": "Al menos un número",
    "password": "Contraseña",
    "password too long": "La contraseña no puede contener más de {{maxNumber}} caracteres",
    "passwords must match": "Las contraseñas deben coincidir",
    "reset password success": "Se ha cambiado tu contraseña.",
    "scan QR code": "Escanea el código QR en tu aplicación",
    "six digit code": "Código de 6 dígitos generado por tu aplicación",
    "special character": "Al menos un símbolo especial (!@#$%^&*()-_=+)",
    "success description": "Ha activado correctamente la autenticación de dos factores.",
    "two-factor authentication": "Autenticación de dos factores",
    "two-factor authentication description": "La autenticación de dos factores es una capa adicional de seguridad que verifica tu identidad mediante algo que sabes (contraseña) y algo que tienes (teléfono, llave de seguridad).",
    "two-factor authentication enabled": "Autenticación de dos factores habilitada correctamente.",
    "two-factor authentication status": "La autenticación de dos factores es:",
    "type text code": "Escribe el código de texto en tu aplicación",
    "uppercase letter": "Al menos una letra mayúscula (A-Z)"
  },
  "Schedules": {
    "activities from": "Actividades de",
    "activities to": "Actividades para",
    "apply button tooltip": "Seleccione al menos un {{resourceName}} y programe para aplicar.",
    "confirm bulk quick schedule": "Está a punto de crear un horario rápido para los conductores seleccionados. ¿Desea continuar?",
    "confirm close": {
      "description": {
        "drivers": {
          "not selected": "Ha seleccionado conductores, pero no se ha elegido ni aplicado ningún horario. ¿Está seguro de que desea continuar?",
          "selected": "Ha seleccionado un horario, pero no lo ha aplicado. ¿Desea aplicar el horario a los conductores seleccionados?"
        },
        "vehicles": {
          "not selected": "Ha seleccionado vehículos, pero no se ha elegido ni aplicado ningún horario. ¿Está seguro de que desea continuar?",
          "selected": "Ha seleccionado un plan, pero no lo ha aplicado. ¿Desea aplicar el plan a los vehículos seleccionados?"
        }
      },
      "title": {
        "not selected": "No se ha seleccionado ni aplicado ningún horario.",
        "selected": "Horario no aplicado. "
      }
    },
    "confirm delete": {
      "description": {
        "drivers": "¿Está seguro de que desea eliminar el horario «{{scheduleName}}»? Esta acción es irreversible y afectará a todos los conductores a los que se les haya aplicado este horario.",
        "vehicles": "¿Está seguro de que desea eliminar el horario «{{scheduleName}}»? Esta acción es irreversible y afectará a todos los vehículos a los que se haya aplicado este horario."
      },
      "title": "¿Eliminar la programación?"
    },
    "create new schedule": "Crear nuevo horario",
    "data types": "Tipos de datos",
    "days": "días",
    "details remove schedule": {
      "description": "¿Estás seguro de que quieres eliminar el horario «{{scheduleName}}»?",
      "title": "¿Eliminar el horario?"
    },
    "download activities": {
      "date info tooltip": "El intervalo de fechas de la actividad debe abarcar al menos dos días.",
      "tooltip text": "TachoSync utiliza un intervalo de descarga adaptativo que garantiza la continuidad ajustando automáticamente el periodo de descarga en función de la última recuperación de datos realizada con éxito. Esto minimiza las lagunas y garantiza que siempre disponga de los datos más recientes, incluso si una descarga programada no se completa durante un par de días."
    },
    "driver number": "Conductor {{driverNum}}",
    "driver schedules": {
      "description": "Los horarios de los conductores le permiten automatizar la descarga de datos del tacógrafo para los conductores seleccionados. Seleccione los conductores a los que desea aplicar un horario. Elija un horario de la lista y haga clic en «Aplicar» para activarlo. Puede crear, editar y eliminar horarios según sea necesario. Nota: Cada empresa puede tener un máximo de 3 horarios de conductores a la vez.",
      "description read-only": "Los horarios de los conductores te permiten automatizar la descarga de datos del tacógrafo para los conductores seleccionados. Los administradores de la empresa pueden crear, editar y eliminar horarios según sea necesario.",
      "title": "Horarios de los conductores"
    },
    "due date": "Fecha de vencimiento",
    "edit schedule": {
      "description": {
        "drivers": {
          "global": "El horario global se aplicará automáticamente a todos los conductores recién añadidos. Esto se puede modificar en la configuración general.",
          "not global": "Los cambios realizados en este horario afectarán a todos los conductores a los que se les aplique dicho horario."
        },
        "vehicles": {
          "global": "El calendario global se aplicará automáticamente a todos los vehículos recién añadidos. Esto se puede modificar en la configuración general.",
          "not global": "Los cambios realizados en este programa afectarán a todos los vehículos a los que se aplique dicho programa."
        }
      },
      "title": {
        "global": "Calendario global",
        "not global": "Editar calendario"
      }
    },
    "enter days": "Introducir días",
    "every": "Cada",
    "fail reason": "Motivo del fallo",
    "file types": {
      "Activities": "Actividades",
      "DetailedSpeed": "Velocidad detallada",
      "EventsAndFaults": "Eventos y fallos",
      "Overview": "Resumen",
      "TechnicalData": "Datos técnicos"
    },
    "global schedule": {
      "connected to root company": "Conectado a la empresa matriz. Calendario global.",
      "global icon info": "El horario global se aplicará automáticamente a todos los {{specificGlobalSchedule}} recién registrados. Puede desactivar esta opción en la configuración de la empresa.",
      "info": {
        "edit driver schedule": "El horario global se aplicará automáticamente a todos los conductores recién registrados. Puede desactivar esta opción en la configuración de la empresa.",
        "edit schedule": "La programación global se aplicará automáticamente a todos los {{ variableName }} recién registrados. Puede desactivar esta opción en la configuración de la empresa.",
        "edit vehicle schedule": "El calendario global se aplicará automáticamente a todos los vehículos recién registrados. Puede desactivar esta opción en la configuración de la empresa."
      },
      "inherited settings": "Las configuraciones de calendario global de la empresa matriz se heredan automáticamente en todas las empresas filiales.",
      "not configured description": "Pulse el botón Editar para comenzar a configurar el calendario global.",
      "not configured description read-only": "Los detalles del calendario aparecerán una vez que se haya configurado.",
      "not configured title": "Calendario global no configurado.",
      "not connected to root company": "No conectado al calendario global de la empresa matriz."
    },
    "include driver data": "Incluir datos del conductor",
    "include driver data tooltip": "Seleccione si la programación rápida también debe descargar los datos de la tarjeta de conductor de los conductores que estén insertados en el tacógrafo en el momento de la ejecución.\n<ul><li>Ninguno: solo se descargarán los datos del vehículo (VU).</li><li>Conductor 1 / Conductor 2: descarga los datos de la ranura del tacógrafo seleccionada si hay una tarjeta de conductor presente.</li><li>Ambos conductores: descarga los datos de ambas ranuras si hay tarjetas presentes.</li></ul>Si no hay ninguna tarjeta de conductor insertada en la ranura seleccionada durante la ejecución, no se descargarán los datos del conductor.",
    "max number reached": "Ha alcanzado el número máximo de horarios permitidos.",
    "name not valid": "El nombre de la programación no puede contener más de {{maxNumber}} caracteres",
    "next attempt": "Siguiente intento",
    "next date": "Próxima fecha",
    "next date and time": "Próxima fecha y hora",
    "next due date": "Próxima fecha de vencimiento",
    "quick schedule": {
      "description": "Seleccione los tipos de datos que desea descargar.",
      "driver schedule quick download new": "Crea una programación única para la descarga de archivos del conductor. Se ejecutará tan pronto como el conductor se conecte a la aplicación.",
      "info banner": {
        "drivers": "Esta es una programación única. La descarga de los datos del conductor se iniciará tan pronto como se detecte la conexión del conductor a TachoSync.",
        "vehicles": "Esta es una programación única. La descarga de datos del vehículo se iniciará tan pronto como se detecte la conexión del vehículo a TachoSync."
      },
      "success banner": "La programación se ha completado; puede eliminarla haciendo clic en «Eliminar programación»",
      "title": "Calendario rápido",
      "vehicle schedule quick download deactivated": "No se puede iniciar una programación rápida en vehículos desactivados. Si desea iniciar una nueva programación rápida, active primero el vehículo.",
      "vehicle schedule quick download new": "Crea una programación única para la descarga de archivos del vehículo. Se ejecutará tan pronto como el vehículo se conecte a la aplicación."
    },
    "repeat": "Repetir",
    "repeat every": "Repetir cada",
    "repeat period": {
      "Biweekly": "Cada 14 días",
      "Custom": "Personalizado",
      "Daily": "Diario",
      "Every28Days": "Cada 28 días",
      "Every90Days": "Cada 90 días",
      "EveryDays": "Cada {{count}} días",
      "Hourly": "Por hora",
      "Monthly": "Mensual",
      "Weekly": "Cada 7 días"
    },
    "schedule details": "Detalles de «{{scheduleName}}»",
    "select date": "Seleccionar fecha",
    "start date": "Fecha de inicio",
    "start date and time": "Fecha y hora de inicio",
    "vehicle schedules": {
      "description": "Los horarios de vehículos le permiten automatizar la descarga de datos del tacógrafo para los vehículos seleccionados. Seleccione los vehículos a los que desea aplicar un horario. Elija un horario de la lista y haga clic en «Aplicar» para activarlo. Puede crear, editar y eliminar horarios según sea necesario. Nota: Cada empresa puede tener un máximo de 3 horarios de vehículos a la vez.",
      "description read-only": "Los horarios de vehículos te permiten automatizar la descarga de datos del tacógrafo para los vehículos seleccionados. Los administradores de la empresa pueden crear, editar y eliminar horarios según sea necesario.",
      "download data activities tooltip hourly": "Se descargarán las actividades del día actual",
      "download data activities tooltip monthly": "Las actividades se descargarán correspondientes a todo el mes anterior a cada fecha de ejecución",
      "download data activities tooltip multiple": "Se descargarán las actividades de los últimos {{repeatDays}} días anteriores a cada fecha de ejecución",
      "download data activities tooltip single": "Las actividades se descargarán correspondientes al último día anterior a cada fecha de ejecución",
      "title": "Horarios de los vehículos"
    }
  },
  "Search": {
    "find device": {
      "error not valid": "El IMEI debe constar de 15 caracteres",
      "find device": "Buscar dispositivo",
      "no vehicle found": "No se ha encontrado ningún vehículo",
      "no vehicle found description": "No se ha encontrado el vehículo. Intente introducir el IMEI de otro dispositivo.",
      "only numbers": "Solo se aceptan números",
      "search for vehicles by their IMEI": "Buscar vehículos por el IMEI de su dispositivo",
      "search vehicle IMEI": "Buscar IMEI del dispositivo"
    },
    "search": "Buscar...",
    "search child company": "Buscar filial",
    "search company name": "Buscar nombre de empresa",
    "search in driverFiles": "Búsqueda por conductor o ID de conductor",
    "search in drivers": "Buscar por nombre o ID de conductor",
    "search in integrations": "Buscar por nombre",
    "search in users": "Buscar por correo electrónico",
    "search in vehicleFiles": "Búsqueda por IMEI o VRN del dispositivo FM",
    "search in vehicles": "Búsqueda por IMEI o VRN del dispositivo FM"
  },
  "Security": {
    "2FA": {
      "get email code": {
        "description": "Utiliza ese código en la siguiente pantalla para verificar tu cuenta.",
        "description modal": "Utiliza ese código para verificar tu cuenta.",
        "title": "Al pulsar «Enviar código», se enviará un código único a <1>{{email}}</1>."
      },
      "select authentication type": {
        "authentication app description": "Obtén un código único desde una aplicación como Microsoft Authenticator o Google Authenticator.",
        "description": "Para mantener la seguridad de su cuenta y de los datos de sus clientes, utilice una de las siguientes opciones para configurar la autenticación de dos factores.",
        "description modal": "Seleccione su método de autenticación preferido.",
        "email": "Correo electrónico",
        "email description": "Te enviaremos un código de un solo uso a tu correo electrónico cada vez que intentes iniciar sesión.",
        "recommended": "Recomendado",
        "title": "La autenticación de dos factores (2FA) es obligatoria para todos los usuarios de TachoSync.",
        "title modal": "Seleccionar método de autenticación"
      },
      "send email code": {
        "description": "Introduzca el código en el campo siguiente y pulse «Verificar» para continuar.",
        "enter code": "Introduzca el código para verificar el correo electrónico.",
        "title": "Se ha enviado un código único a <1>{{email}}</1>.",
        "verification code": "Código de verificación"
      },
      "send otp code": {
        "click to scan code": "Haga clic aquí para escanear un código QR",
        "click to type code": "Haga clic aquí para introducir el código manualmente",
        "incorrect code": "Código incorrecto",
        "scan QR code": "Escanea el código QR en tu aplicación",
        "six digit code": "Código de 6 dígitos generado por tu aplicación",
        "title": "Necesitarás una aplicación móvil de autenticación para completar este proceso, como: <1>Microsoft Authenticator</1> o <2>Google Authenticator</2>.",
        "type text code": "Escribe el código de texto en tu aplicación"
      },
      "success message": {
        "alert": "Autenticación de dos factores habilitada correctamente.",
        "description": "Te pediremos un código de autenticación cada vez que inicies sesión con tu correo electrónico y contraseña.",
        "title": "Ha activado correctamente la autenticación de dos factores.",
        "title modal": "¡Autenticación de dos factores activada!"
      },
      "title": {
        "authentication app": "Aplicación de autenticación",
        "authentication email": "Correo electrónico de autenticación",
        "is enabled": "Autenticación de dos factores habilitada.",
        "protect your account": "Protege tu cuenta de TachoSync"
      }
    }
  },
  "Selector": {
    "client company": "Empresa cliente",
    "companies": "Empresas ({{companyCount}})",
    "company selector": "Selector de empresas"
  },
  "Settings": {
    "CCA file size": "Tamaño del archivo: 83,5 MB",
    "change password": "Cambiar contraseña",
    "company card authenticator": "Autenticador de tarjetas de empresa",
    "email notifications": {
      "credits purchased": "Créditos adquiridos",
      "low credits alerts": "Alertas de saldo bajo",
      "title": "Notificaciones por correo electrónico",
      "tooltip": "Gestiona qué correos electrónicos relacionados con el crédito deseas recibir."
    },
    "feature switches": "Conmutadores de funciones",
    "file format settings": {
      "description": "Elija en qué formato se deben mostrar los archivos del tacógrafo. Los formatos disponibles son el europeo (.DDD), el francés (.V1B para los datos del vehículo y .C1B para los datos del conductor) y el español (.TGD).",
      "title": "Configuración del formato de archivo"
    },
    "file formats": {
      "DDD": ".DDD",
      "TGD": ".TGD",
      "V1BC1B": ".V1B, .C1B"
    },
    "general settings": "Configuración general",
    "security": "Seguridad",
    "time settings": {
      "date display format tooltip": "Seleccione un formato para mostrar la fecha en TachoSync.\nPor ejemplo: DD-MM-AAAA = 14-05-2024",
      "description": "Configure la zona horaria automáticamente utilizando su ubicación actual, o elija su zona horaria preferida y el formato en el que se mostrarán todas las marcas de tiempo.",
      "time and date format toggle": "Configurar automáticamente el formato de fecha y hora",
      "title": "Configuración de la hora"
    },
    "tutorials": "Tutoriales",
    "version": "Versión"
  },
  "Table": {
    "activity period": "Periodo de actividad",
    "Automatic initial Driver Download": "Descarga automática de los datos iniciales del conductor",
    "Automatic initial Vehicle Download": "Descarga automática inicial del vehículo",
    "card name": "Nombre",
    "card number": "Identificación del conductor",
    "cardnumber": "Identificación del conductor",
    "comment": "Comentario",
    "company": "Empresa",
    "connection status": "Estado de la conexión",
    "created at": "Creado en",
    "created by": "Creado por",
    "credit status": "Situación crediticia",
    "data types": "Tipos de datos",
    "day ago": "Hace 1 día",
    "days ago": "Hace {{daysNum}} días",
    "description": "Descripción",
    "device imei": "IMEI del dispositivo",
    "device imei empty": "El vehículo no tiene ningún IMEI añadido. Se necesita un IMEI válido para conectar el dispositivo y descargar archivos. Ve a editar el vehículo y añade un IMEI válido para permitir la descarga de archivos del vehículo.",
    "device status": "Estado del dispositivo",
    "downloaded at": "Descargado en",
    "driver": "Conductor",
    "driver name": "Nombre del conductor",
    "drivers name": "Nombre del conductor",
    "email": "Correo electrónico",
    "empty table": {
      "button": {
        "add": {
          "analysis providers": "Añadir integración",
          "driver files": "Añadir archivo de conductor",
          "drivers": "Añadir conductor",
          "integrations": "Añadir integración",
          "integrations api": "Añadir integración",
          "users": "Invitar a un usuario",
          "vehicle files": "Añadir archivo de vehículo",
          "vehicles": "Añadir vehículo"
        },
        "reset view": "Restablecer vista"
      },
      "no initial results": {
        "description": {
          "analysis providers": "En cuanto se añadan proveedores de análisis a TachoSync, \npodrás ver la lista aquí.",
          "companies": "En cuanto se añadan empresas a TachoSync,\npodrás ver la lista aquí.",
          "company cards": "En cuanto se añadan las tarjetas de empresa, podrás ver la lista aquí.",
          "driver files": "En cuanto se añadan los archivos de los conductores a TachoSync,\npodrá ver la lista aquí.",
          "drivers": "En cuanto se añadan conductores a TachoSync,\npodrá ver la lista aquí.",
          "integrations": "Tan pronto como se añadan integraciones a TachoSync, \npodrás ver la lista aquí.",
          "integrations api": "En cuanto se creen las claves API para su empresa,\npodrá ver la lista aquí.",
          "users": "En cuanto se añadan usuarios a TachoSync, \npodrás ver la lista aquí.",
          "users invitations": "En cuanto se invite a los usuarios a TachoSync,\npodrá ver la lista aquí.",
          "vehicle files": "En cuanto se añadan los archivos de los vehículos a TachoSync,\npodrá ver la lista aquí.",
          "vehicles": "En cuanto se añadan vehículos a TachoSync,\npodrá ver la lista aquí."
        },
        "title": {
          "analysis providers": "Aún no hay proveedores de análisis",
          "companies": "La tabla de empresas está vacía",
          "company cards": "La tabla de tarjetas de empresa está vacía",
          "driver files": "La tabla de archivos de conductores está vacía",
          "drivers": "La tabla de conductores está vacía",
          "integrations": "Aún no hay integraciones",
          "integrations api": "Aún no hay claves API",
          "users": "La tabla de usuarios está vacía",
          "users invitations": "La tabla de invitaciones de usuarios está vacía",
          "vehicle files": "La tabla de archivos de vehículos está vacía",
          "vehicles": "La tabla de vehículos está vacía"
        }
      },
      "no results found": {
        "description": "Prueba con otra palabra clave o filtro para obtener más \nresultados.",
        "title": "No se han encontrado resultados"
      }
    },
    "enable": "Habilitar",
    "expiration date": "Fecha de caducidad",
    "expired integration tooltip": "La integración ha caducado y no se puede activar",
    "file name": "Nombre del archivo",
    "Global schedule": "Calendario global",
    "imei": "IMEI",
    "invitation status": "Estado de la invitación",
    "invited at": "Invitado en",
    "invited by": "Por invitación de",
    "last activity": "Última actividad",
    "last connected": "Última conexión",
    "last connection": "Última conexión",
    "last download": "Última descarga",
    "last download date": "Última descarga: {{date}}",
    "last event": "Último evento",
    "last vehicle used": "Último vehículo utilizado",
    "method": "Método",
    "name": "Nombre",
    "next download": "Siguiente descarga",
    "No schedule applied": "No se aplica ningún horario",
    "No schedules": "Sin horarios",
    "number": "Número",
    "Overdue": "Vencido",
    "parent company": "Empresa matriz",
    "plate number": "Número de matrícula",
    "provider": "Proveedor",
    "Quick schedule": "Calendario rápido",
    "role": "Función",
    "rows per page": "Filas por página",
    "schedule": "Horario",
    "schedules": "Horarios",
    "seen at": "Visto en",
    "select columns to show": "Seleccionar columnas para mostrar",
    "show details": {
      "companies": "Mostrar datos de la empresa",
      "drivers": "Mostrar detalles del conductor",
      "integrations": "Mostrar detalles de la integración",
      "vehicles": "Mostrar detalles del vehículo"
    },
    "status": "Estado",
    "today": "Hoy",
    "updated at": "Actualizado el",
    "vehicle": "Vehículo",
    "vehicle name": "Nombre del vehículo",
    "vehicle number": "VRN",
    "vehicles": "Vehículos"
  },
  "Tabs": {
    "analysis providers": "Proveedores de análisis",
    "api": "API",
    "invitations": "Invitaciones",
    "sftp": "SFTP",
    "users": "Usuarios"
  },
  "Tooltip": {
    "delete company action": "Una o varias de las empresas seleccionadas tienen filiales y no se pueden eliminar. Primero elimine todas las filiales para poder eliminar las empresas seleccionadas.",
    "no action permission": "No tienes permiso para realizar esta acción",
    "parent company": "El número máximo de niveles permitidos en el árbol de la empresa es {{maxAllowedLevels}}. La empresa «{{companyName}}» se encuentra en el nivel {{maxAllowedLevels}} y no se le pueden añadir empresas secundarias."
  },
  "Tutorials": {
    "add company card": {
      "desktop": {
        "fifth step": {
          "content": "Para añadir una nueva tarjeta de empresa, haz clic en el botón resaltado «Añadir<strong> nueva</strong>». Cuando aparezca la pantalla para añadir una empresa, rellena los campos necesarios y haz clic en el botón «Guardar» para finalizar.\n\nNota: El ID de la tarjeta de empresa se encuentra en el Autenticador de tarjetas de empresa, en la columna «ID de tarjeta».\n\nHaz clic en «Siguiente» para continuar.",
          "title": "Añadir una nueva tarjeta de empresa"
        },
        "final step": {
          "content": "Todas las tarjetas añadidas y sus detalles aparecerán en la sección «Tarjetas de la empresa».\n\nNota: Siempre puede volver a realizar este tutorial yendo a «Configuración» - «Tutoriales». \n\nHaga clic en <strong>«Finalizar</strong>» para completar el tutorial.",
          "title": "Datos de la tarjeta de empresa"
        },
        "first step": {
          "content": "Antes de añadir una tarjeta de empresa en TachoSync, asegúrate de haber descargado e instalado el Company Card Authenticator. Puedes hacerlo en cualquier momento desde el menú de Ajustes.\n\nEl Company Card Authenticator leerá y mostrará la información de las tarjetas de empresa insertadas en tu lector de tarjetas y habilitará la autenticación remota.\n\nHaz clic en<strong> «Empezar</strong>» para comenzar.",
          "title": "Autenticador de tarjetas de empresa"
        },
        "fourth step": {
          "content": "A la derecha, puede ver el panel de datos de la empresa. Aquí encontrará toda la información sobre la empresa creada.\n\nHaga clic en «Siguiente» para continuar.",
          "title": "Datos de la empresa"
        },
        "second step": {
          "content": "Utilizando la barra lateral izquierda, vaya a la página <strong>«Empresas»</strong> resaltada.",
          "title": "Página de empresas"
        },
        "third step": {
          "content": "Para ver la pantalla de fichas de empresas, primero debe hacer clic en una de las empresas.\n\nPara este tutorial, seleccione la empresa resaltada, que se encuentra en la parte superior de la tabla.",
          "title": "Elija una empresa"
        }
      },
      "mobile": {
        "fifth step": {
          "content": "Para añadir una nueva tarjeta de empresa, haga clic en el botón resaltado «Añadir nueva». Cuando aparezca la pantalla para añadir una empresa, rellene los campos necesarios y haga clic en el botón «Guardar» para finalizar.\n\nNota: El ID de la tarjeta de empresa se encuentra en el Autenticador de tarjetas de empresa, en la columna «ID de tarjeta» de la tabla.\n\nHaga clic en «Siguiente» para continuar.",
          "title": "Añadir una nueva tarjeta de empresa"
        },
        "final step": {
          "content": "Todas las tarjetas añadidas aparecerán en la sección resaltada «Tarjetas de empresa». Allí podrá ver el estado de la tarjeta, la fecha de validez y el ID.\n\nNota: Siempre puede volver a realizar este tutorial yendo a «Configuración» - «Tutoriales». \n\nHaga clic en «Finalizar» para completar el tutorial.",
          "title": "Datos de la tarjeta de empresa"
        },
        "first step": {
          "content": "Primero debemos ir a la <strong>página Empresas</strong>, que se encuentra en el menú, en la parte superior derecha.\n\nHaga clic en el área resaltada para abrir el <strong>menú</strong>.",
          "title": "Abrir el menú"
        },
        "fourth step": {
          "content": "Aquí encontrará toda la información sobre la empresa creada.\n\nHaga clic en «Siguiente» para continuar.",
          "title": "Datos de la empresa"
        },
        "second step": {
          "content": "Para abrir la <strong>página de Empresas</strong>, haz clic en el área resaltada.",
          "title": "Página de empresas"
        },
        "third step": {
          "content": "Aquí puede ver la lista de todas las empresas.\nPara ver la ficha de una empresa, abra la pantalla <strong>de detalles de la empresa</strong> haciendo clic en el botón resaltado.",
          "title": "Más detalles"
        }
      },
      "name": "Añadir tarjeta de empresa"
    },
    "add vehicle": {
      "first step": {
        "content": "Para aplicar un horario, es necesario haber añadido al menos un vehículo.\n\nAñadamos un vehículo pulsando el botón resaltado <strong>«Añadir vehículo</strong>».\n\nEn la siguiente pantalla, rellene todos los campos necesarios y pulse el botón «Añadir» para finalizar la adición del vehículo.",
        "title": "No hay vehículos añadidos"
      },
      "name": "Añadir vehículo"
    },
    "apply schedule": {
      "desktop": {
        "fifth step": {
          "content": "Una vez que haya seleccionado un horario, se activará el botón «Aplicar».\n\nHaga clic en el botón «Aplicar».\n\nHaga clic en «Siguiente» para continuar.",
          "title": "Selecciona un horario para aplicarlo"
        },
        "final step": {
          "content": "Cuando se aplica correctamente un horario a un vehículo, la descarga de datos comenzará según la hora programada.\n\nTodos los horarios aplicados a un vehículo o conductor se mostrarán en el panel resaltado «Más detalles».\n\nHaga clic en <strong>«Finalizar</strong>» para completar el tutorial.",
          "title": "Horario aplicado correctamente"
        },
        "first step": {
          "content": "Los horarios de los vehículos se encuentran en la página Vehículos, mientras que los horarios de los conductores se encuentran en la página Conductores.\n\nDado que el proceso es similar en ambas páginas, para este tutorial, seleccione la página <strong>«Vehículos</strong>» resaltada.",
          "title": "Horario de vehículos o conductores"
        },
        "fourth step": {
          "content": "Haga clic en un programa para aplicarlo al vehículo o vehículos seleccionados.\n\nHaga clic en <strong>«Siguiente</strong>» para continuar",
          "title": "Selecciona un horario para aplicarlo"
        },
        "second step": {
          "content": "Antes de aplicar un horario, seleccione uno o varios vehículos.\n\nPara este tutorial, seleccione el <strong>primer vehículo de la tabla </strong> haciendo clic en el botón resaltado.",
          "title": "Seleccionar un vehículo"
        },
        "third step": {
          "content": "Ahora que ha seleccionado un vehículo, el botón «Horarios» se activará.\n\nHaga clic en el botón <strong>«Horarios»</strong> resaltado para continuar.",
          "title": "Horarios abiertos"
        }
      },
      "mobile": {
        "fifth step": {
          "content": "Ahora que ha seleccionado un vehículo, el botón «Horarios» debería aparecer resaltado.\n\nHaga clic en el botón <strong>«Horarios</strong>» resaltado para continuar.",
          "title": "Horarios abiertos"
        },
        "final step": {
          "content": "Cuando se aplica correctamente un horario a un vehículo, la descarga de datos comenzará según la hora programada.\nTodos los horarios aplicados a un vehículo o conductor se mostrarán en el panel resaltado <strong>«Más detalles</strong>».\n\nHaga clic en <strong>«Finalizar</strong>» para completar el tutorial.",
          "title": "Horario aplicado correctamente"
        },
        "first step": {
          "content": "Los horarios de los vehículos se encuentran en la página Vehículos, mientras que los horarios de los conductores se encuentran en la página Conductores.\n\nDado que el proceso es similar en ambas páginas, para este tutorial seleccionemos la <strong>«página</strong> Vehículos» resaltada.",
          "title": "Horario de vehículos o conductores"
        },
        "fourth step": {
          "content": "Para este tutorial, seleccionemos el primer vehículo de la tabla haciendo clic en el botón resaltado.",
          "title": "Seleccionar un vehículo"
        },
        "second step": {
          "content": "Dado que el proceso es similar en ambas páginas, para este tutorial seleccionemos la <strong>«página</strong> de vehículos» resaltada.",
          "title": "Página de vehículos"
        },
        "seventh step": {
          "content": "Una vez seleccionado un horario, el botón «<strong>Aplicar</strong>», que aparece resaltado, se activará. Al hacer clic en él, se aplicará el horario al vehículo seleccionado.\n\nHaga clic en <strong>«Siguiente</strong>» para continuar.",
          "title": "Selecciona un horario para aplicarlo"
        },
        "sixth step": {
          "content": "Después de seleccionar el vehículo, puede elegir un horario para aplicarlo haciendo clic en él.\n\nHaga clic en «Siguiente» para continuar",
          "title": "Selecciona un horario para aplicarlo"
        },
        "third step": {
          "content": "Primero debe seleccionar uno o varios vehículos antes de aplicarles un horario.\nPara empezar, haga clic en el botón resaltado <strong>«Seleccionar</strong> filas».",
          "title": "Abrir herramienta de selección"
        }
      },
      "name": "Aplicar horario"
    },
    "company selector": {
      "desktop": {
        "first step": {
          "content": "En el menú superior, el selector de empresas permite elegir la empresa con la que desea interactuar en TachoSync.\nEsto es necesario cuando se gestionan varias empresas.\n\nHaga clic en el botón <strong>resaltado</strong> para abrir el selector de empresas.",
          "title": "Abrir selector de empresas"
        },
        "second step": {
          "content": "La pantalla de selección de empresa te permite elegir una empresa concreta con la que trabajar. En los demás menús, solo verás recursos relacionados con la empresa seleccionada. Al cerrar sesión en TachoSync, siempre se guardará la última selección utilizada.",
          "title": "Selector de empresas"
        }
      },
      "mobile": {
        "first step": {
          "content": "En el menú superior, el selector de empresas permite elegir la empresa con la que desea interactuar en TachoSync.\nEsto es necesario cuando se gestionan varias empresas.\n\nHaga clic en el botón <strong>resaltado</strong> para abrir el selector de empresas.",
          "title": "Abrir selector de empresas"
        },
        "second step": {
          "content": "La pantalla de selección de empresa te permite elegir una empresa concreta con la que trabajar. En los demás menús, solo verás recursos relacionados con la empresa seleccionada. Al cerrar sesión en TachoSync, siempre se guardará la última selección utilizada.",
          "title": "Selector de empresas"
        }
      },
      "name": "Selector de empresas"
    },
    "create schedule": {
      "desktop": {
        "fifth step": {
          "content": "Una vez creado un horario, es necesario aplicarlo a los vehículos o conductores seleccionados. Consulte el tutorial «<strong>Aplicar </strong>horario» para saber cómo aplicar los horarios.\n\nHaga clic en «Siguiente» para continuar.",
          "title": "Horario no aplicado"
        },
        "final step": {
          "content": "Enhorabuena, ha aprendido a crear un horario correctamente.\n\nA continuación, aprenda a aplicar un horario a los elementos seleccionados.\n\nHaga clic en <strong>«Finalizar</strong>» para completar el tutorial.",
          "title": "Crear un horario - completado"
        },
        "first step": {
          "content": "Una programación es un plan preestablecido que descarga automáticamente los datos del tacógrafo de sus vehículos o conductores en momentos e intervalos específicos. Al establecer una fecha de inicio, una hora y una frecuencia (por ejemplo, diaria), la programación garantiza que los datos se recopilen de forma constante sin necesidad de realizar acciones manuales.\n\nHaga clic en<strong> «Empezar</strong>» para comenzar.",
          "title": "¿Qué es un horario?"
        },
        "fourth step": {
          "content": "En esta pantalla, puede crear, editar, pausar o eliminar programaciones. El primer espacio está siempre reservado para la programación global, que no se puede eliminar.",
          "title": "Horarios"
        },
        "second step": {
          "content": "Los horarios de los vehículos se encuentran en la página «Vehículos». Los horarios de los conductores se encuentran en la página «Conductores».\n\nDado que el proceso es similar en ambas páginas, para este tutorial, seleccione la página <strong>«Vehículos»</strong> resaltada.",
          "title": "Horario de vehículos o conductores"
        },
        "third step": {
          "content": "Se puede crear y editar un horario en la ventana «Horarios» en cualquier momento, independientemente de si se han añadido vehículos o conductores.\n\nHaga clic en el botón <strong>«Horarios</strong>» resaltado para continuar.",
          "title": "Horarios abiertos"
        }
      },
      "mobile": {
        "fifth step": {
          "content": "En esta pantalla puede crear, editar, pausar o eliminar cualquier programación creada. El primer espacio está siempre reservado para la programación global, que no se puede eliminar.",
          "title": "Horarios"
        },
        "final step": {
          "content": "Enhorabuena, ya sabes cómo crear un horario.\n\nA continuación, aprende a aplicar un horario a los elementos seleccionados.\n\nHaz clic en <strong>«Finalizar</strong>» para completar el tutorial.",
          "title": "Crear un horario - completado"
        },
        "first step": {
          "content": "Una programación es un plan preestablecido que descarga automáticamente los datos del tacógrafo de sus vehículos o conductores en momentos e intervalos específicos. Al establecer una fecha de inicio, una hora y una frecuencia (por ejemplo, diaria), la programación garantiza que los datos se recopilen de forma constante sin necesidad de intervención manual.\n\nHaga clic en<strong> </strong>«<strong>Empezar</strong>» para comenzar.",
          "title": "¿Qué es un horario?"
        },
        "fourth step": {
          "content": "Se puede crear y editar un horario en la ventana «Horarios» en cualquier momento, independientemente de si se han añadido vehículos o conductores.\n\nHaga clic en el botón <strong>«Horarios</strong>» resaltado para continuar.",
          "title": "Horarios abiertos"
        },
        "second step": {
          "content": "Los horarios de los vehículos se encuentran en la página Vehículos, mientras que los horarios de los conductores se encuentran en la página Conductores.\n\nPara acceder a estas páginas, primero abramos el <strong>menú</strong>.",
          "title": "Horario de vehículos o conductores"
        },
        "sixth step": {
          "content": "Una vez creado un horario, es necesario aplicarlo a <strong>los</strong> vehículos o conductores seleccionados. En otro tutorial, <strong>«Aplicar </strong>horario», se explica cómo realizar esta acción.\n\nHaga clic en <strong>«Sigu</strong>iente» para continuar.",
          "title": "Horario no aplicado"
        },
        "third step": {
          "content": "Dado que el proceso es similar en ambas páginas, para este tutorial seleccionemos la <strong>«página</strong> de <strong>vehículos</strong>» resaltada",
          "title": "Página de vehículos"
        }
      },
      "name": "Crear horario"
    }
  }
}
